var bodyScrollLockOptions = {
  reserveScrollBarGap: true,
};

// Define a global function to load a script
window.loadScript = function (url) {
  // Check if the script already exists
  var existingScript = document.querySelector(`script[src="${url}"]`);

  if (existingScript) {
    return;
  }

  // Create a new script element
  var script = document.createElement("script");
  script.src = url;
  document.body.appendChild(script);
};

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, comma, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    if (comma == false) dollars = dollars.replace(/,/g, ' ');

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0, false);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, true, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, true, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

/**
 * DOM event delegator
 *
 * The delegator will listen
 * for events that bubble up
 * to the root node.
 *
 * @constructor
 * @param {Node|string} [root] The root node or a selector string matching the root node
 */
function Delegate(root) {
  /**
   * Maintain a map of listener
   * lists, keyed by event name.
   *
   * @type Object
   */
  this.listenerMap = [{}, {}];
  if (root) {
    this.root(root);
  }

  /** @type function() */
  this.handle = Delegate.prototype.handle.bind(this);

  // Cache of event listeners removed during an event cycle
  this._removedListeners = [];
}

/**
 * Start listening for events
 * on the provided DOM element
 *
 * @param  {Node|string} [root] The root node or a selector string matching the root node
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.root = function (root) {
  const listenerMap = this.listenerMap;
  let eventType;

  // Remove master event listeners
  if (this.rootElement) {
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, true);
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, false);
      }
    }
  }

  // If no root or root is not
  // a dom node, then remove internal
  // root reference and exit here
  if (!root || !root.addEventListener) {
    if (this.rootElement) {
      delete this.rootElement;
    }
    return this;
  }

  /**
   * The root node at which
   * listeners are attached.
   *
   * @type Node
   */
  this.rootElement = root;

  // Set up master event listeners
  for (eventType in listenerMap[1]) {
    if (listenerMap[1].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, { capture: true, passive: isScrollEvent });
    }
  }
  for (eventType in listenerMap[0]) {
    if (listenerMap[0].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, { capture: false, passive: isScrollEvent });
    }
  }

  return this;
};

/**
 * @param {string} eventType
 * @returns boolean
 */
Delegate.prototype.captureForType = function (eventType) {
  return (
    ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(
      eventType
    ) !== -1
  );
};

/**
 * Attach a handler to one
 * event for all elements
 * that match the selector,
 * now or in the future
 *
 * The handler function receives
 * three arguments: the DOM event
 * object, the node that matched
 * the selector while the event
 * was bubbling and a reference
 * to itself. Within the handler,
 * 'this' is equal to the second
 * argument.
 *
 * The node that actually received
 * the event can be accessed via
 * 'event.target'.
 *
 * @param {string} eventType Listen for these events
 * @param {string|undefined} selector Only handle events on elements matching this selector, if undefined match root element
 * @param {function()} handler Handler function - event data passed here will be in event.data
 * @param {boolean} [useCapture] see 'useCapture' in <https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener>
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
  let root;
  let listenerMap;
  let matcher;
  let matcherParam;

  if (!eventType) {
    throw new TypeError("Invalid event type: " + eventType);
  }

  // handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // Fallback to sensible defaults
  // if useCapture not set
  if (useCapture === undefined) {
    useCapture = this.captureForType(eventType);
  }

  if (typeof handler !== "function") {
    throw new TypeError("Handler must be a type of Function");
  }

  root = this.rootElement;
  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  const isScrollEvent = ["wheel", "mousewheel", "touchstart", "touchmove"].indexOf(eventType) !== -1;

  // Add master handler for type if not created yet
  if (!listenerMap[eventType]) {
    if (root) {
      root.addEventListener(eventType, this.handle, { capture: useCapture, passive: isScrollEvent });
    }
    listenerMap[eventType] = [];
  }

  if (!selector) {
    matcherParam = null;

    // COMPLEX - matchesRoot needs to have access to
    // this.rootElement, so bind the function to this.
    matcher = matchesRoot.bind(this);

    // Compile a matcher for the given selector
  } else if (/^[a-z]+$/i.test(selector)) {
    matcherParam = selector;
    matcher = matchesTag;
  } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
    matcherParam = selector.slice(1);
    matcher = matchesId;
  } else {
    matcherParam = selector;
    matcher = Element.prototype.matches;
  }

  // Add to the list of listeners
  listenerMap[eventType].push({
    selector: selector,
    handler: handler,
    matcher: matcher,
    matcherParam: matcherParam,
  });

  return this;
};

/**
 * Remove an event handler
 * for elements that match
 * the selector, forever
 *
 * @param {string} [eventType] Remove handlers for events matching this type, considering the other parameters
 * @param {string} [selector] If this parameter is omitted, only handlers which match the other two will be removed
 * @param {function()} [handler] If this parameter is omitted, only handlers which match the previous two will be removed
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
  let i;
  let listener;
  let listenerMap;
  let listenerList;
  let singleEventType;

  // Handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // If useCapture not set, remove
  // all event listeners
  if (useCapture === undefined) {
    this.off(eventType, selector, handler, true);
    this.off(eventType, selector, handler, false);
    return this;
  }

  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  if (!eventType) {
    for (singleEventType in listenerMap) {
      if (listenerMap.hasOwnProperty(singleEventType)) {
        this.off(singleEventType, selector, handler);
      }
    }

    return this;
  }

  listenerList = listenerMap[eventType];
  if (!listenerList || !listenerList.length) {
    return this;
  }

  // Remove only parameter matches
  // if specified
  for (i = listenerList.length - 1; i >= 0; i--) {
    listener = listenerList[i];

    if (
      (!selector || selector === listener.selector) &&
      (!handler || handler === listener.handler)
    ) {
      this._removedListeners.push(listener);
      listenerList.splice(i, 1);
    }
  }

  // All listeners removed
  if (!listenerList.length) {
    delete listenerMap[eventType];

    // Remove the main handler
    if (this.rootElement) {
      this.rootElement.removeEventListener(eventType, this.handle, useCapture);
    }
  }

  return this;
};

/**
 * Handle an arbitrary event.
 *
 * @param {Event} event
 */
Delegate.prototype.handle = function (event) {
  let i;
  let l;
  const type = event.type;
  let root;
  let phase;
  let listener;
  let returned;
  let listenerList = [];
  let target;
  const eventIgnore = "ftLabsDelegateIgnore";

  if (event[eventIgnore] === true) {
    return;
  }

  target = event.target;

  // Hardcode value of Node.TEXT_NODE
  // as not defined in IE8
  if (target.nodeType === 3) {
    target = target.parentNode;
  }

  // Handle SVG <use> elements in IE
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  root = this.rootElement;

  phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);

  // eslint-disable-next-line default-case
  switch (phase) {
    case 1: //Event.CAPTURING_PHASE:
      listenerList = this.listenerMap[1][type];
      break;
    case 2: //Event.AT_TARGET:
      if (this.listenerMap[0] && this.listenerMap[0][type]) {
        listenerList = listenerList.concat(this.listenerMap[0][type]);
      }
      if (this.listenerMap[1] && this.listenerMap[1][type]) {
        listenerList = listenerList.concat(this.listenerMap[1][type]);
      }
      break;
    case 3: //Event.BUBBLING_PHASE:
      listenerList = this.listenerMap[0][type];
      break;
  }

  let toFire = [];

  // Need to continuously check
  // that the specific list is
  // still populated in case one
  // of the callbacks actually
  // causes the list to be destroyed.
  l = listenerList.length;
  while (target && l) {
    for (i = 0; i < l; i++) {
      listener = listenerList[i];

      // Bail from this loop if
      // the length changed and
      // no more listeners are
      // defined between i and l.
      if (!listener) {
        break;
      }

      if (
        target.tagName &&
        ["button", "input", "select", "textarea"].indexOf(
          target.tagName.toLowerCase()
        ) > -1 &&
        target.hasAttribute("disabled")
      ) {
        // Remove things that have previously fired
        toFire = [];
      }
      // Check for match and fire
      // the event if there's one
      //
      // TODO:MCG:20120117: Need a way
      // to check if event#stopImmediatePropagation
      // was called. If so, break both loops.
      else if (listener.matcher.call(target, listener.matcherParam, target)) {
        toFire.push([event, target, listener]);
      }
    }

    // TODO:MCG:20120117: Need a way to
    // check if event#stopPropagation
    // was called. If so, break looping
    // through the DOM. Stop if the
    // delegation root has been reached
    if (target === root) {
      break;
    }

    l = listenerList.length;

    // Fall back to parentNode since SVG children have no parentElement in IE
    target = target.parentElement || target.parentNode;

    // Do not traverse up to document root when using parentNode, though
    if (target instanceof HTMLDocument) {
      break;
    }
  }

  let ret;

  for (i = 0; i < toFire.length; i++) {
    // Has it been removed during while the event function was fired
    if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
      continue;
    }
    returned = this.fire.apply(this, toFire[i]);

    // Stop propagation to subsequent
    // callbacks if the callback returned
    // false
    if (returned === false) {
      toFire[i][0][eventIgnore] = true;
      toFire[i][0].preventDefault();
      ret = false;
      break;
    }
  }

  return ret;
};

/**
 * Fire a listener on a target.
 *
 * @param {Event} event
 * @param {Node} target
 * @param {Object} listener
 * @returns {boolean}
 */
Delegate.prototype.fire = function (event, target, listener) {
  return listener.handler.call(target, event, target);
};

/**
 * Check whether an element
 * matches a tag selector.
 *
 * Tags are NOT case-sensitive,
 * except in XML (and XML-based
 * languages such as XHTML).
 *
 * @param {string} tagName The tag name to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesTag(tagName, element) {
  return tagName.toLowerCase() === element.tagName.toLowerCase();
}

/**
 * Check whether an element
 * matches the root.
 *
 * @param {?String} selector In this case this is always passed through as null and not used
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesRoot(selector, element) {
  if (this.rootElement === window) {
    return (
      // Match the outer document (dispatched from document)
      element === document ||
      // The <html> element (dispatched from document.body or document.documentElement)
      element === document.documentElement ||
      // Or the window itself (dispatched from window)
      element === window
    );
  }
  return this.rootElement === element;
}

/**
 * Check whether the ID of
 * the element in 'this'
 * matches the given ID.
 *
 * IDs are case-sensitive.
 *
 * @param {string} id The ID to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesId(id, element) {
  return id === element.id;
}

/**
 * Short hand for off()
 * and root(), ie both
 * with no parameters
 *
 * @return void
 */
Delegate.prototype.destroy = function () {
  this.off();
  this.root();
};

class Popup {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="open-modal"]',
      this.openModal.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="close-modal"]',
      this.closeModal.bind(this)
    );
    document.addEventListener(
      "posted_successfully",
      this.openModalSpecial.bind(this)
    );

    this.onClickOutsideListener = this.closeModal.bind(this);
  }

  openModal() {
    event.preventDefault();
    event.stopPropagation();
    this.pageOverlayElement.classList.add("is-visible");
    this.activeModal = document.getElementById(
      event.target.getAttribute("aria-controls")
    );
    this.activeModal.setAttribute("aria-hidden", "false");
    this.activeModal.style.display = "block";
    this.pageOverlayElement.addEventListener(
      "click",
      this.onClickOutsideListener
    );
    var focus = this.activeModal.querySelector("[data-scrollable]");
    setTimeout(() => {
      trapFocus(this.activeModal);
      bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    }, 100);

  }
  openModalSpecial() {
    event.preventDefault();
    event.stopPropagation();
    this.pageOverlayElement.classList.add("is-visible");
    this.activeModal = document.getElementById(event.detail.id);
    this.activeModal.setAttribute("aria-hidden", "false");
   var focus = this.activeModal.querySelector("[data-scrollable]");
    this.pageOverlayElement.addEventListener(
      "click",
      this.onClickOutsideListener
    );
   bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    trapFocus(this.activeModal);
  }
  closeModal() {
    this.activeModal = document.body.querySelector(
      '.Popup[aria-hidden="false"]'
    );
    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener(
      "click",
      this.onClickOutsideListener
    );
    this.activeModal.setAttribute("aria-hidden", "true");

    bodyScrollLock.clearAllBodyScrollLocks();
    this.activeModal.removeAttribute("style");
  }
}

class RevolutionImageZoom {
  constructor(element, slideshow) {
    this.element = element;
    this.slideshow = slideshow;
    this.delegateElement = new Delegate(this.element);
    this.delegateRoot = new Delegate(document.body);
    loadScript(window.theme.pswpScript);
    this.syncHeight();
    this.bindEvents();
  }

  syncHeight() {
    document.documentElement.style.setProperty(
      "--window-inner-height",
      `${window.innerHeight}px`
    );
  }

  bindEvents() {
    window.addEventListener("resize", this.syncHeight());
    this.delegateElement.on(
      "click",
      '[data-action="open-product-zoom"]',
      this.initPhotoSwipe.bind(this)
    );
    this.delegateElement.on(
      "click",
      ".ProductSliderCell--Zoom",
      this.initPhotoSwipeFromImageClick.bind(this)
    );
    // Keyboard: open zoom for focusable product images (desktop) and zoom button (mobile).
    this.delegateElement.on(
      "keydown",
      ".ProductSliderCell--Zoom[role='button']",
      (event, target) => {
        const key = event.key;
        if (key !== "Enter" && key !== " " && key !== "Spacebar") return;
        event.preventDefault();
        this.initPhotoSwipeFromImageClick(event, target);
      }
    );
    this.delegateElement.on(
      "keydown",
      '[data-action="open-product-zoom"]',
      (event) => {
        const key = event.key;
        if (key !== "Enter" && key !== " " && key !== "Spacebar") return;
        event.preventDefault();
        this.initPhotoSwipe();
      }
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoswiperClose.bind(this)
    );
  }
  photoswiperClose() {
    this.photoSwipeInstance.close;
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.remove("pswp-open-in-ios");
    }
  }

  initPhotoSwipe() {
    var images = [],
      index = 0;
    if (this.slideshow) {
      this.slideshow.swiperElement.slides.forEach(function (item) {
        if (item.classList.contains("ProductSliderCell--Zoom")) {
          if (item.querySelector("img")) {
            images.push(item.querySelector("img"));
          }
        }
      });
      var index_currentSlide = this.slideshow.swiperElement.realIndex;
      this.slideshow.swiperElement.slides[index_currentSlide]
        .querySelector(".ProductSlider--Element")
        .getAttribute("data-image-position");
    } else {
      images.push(document.querySelector(".ProductSlider--Image"));
    }

    this.createPhotoSwipeInstance(
      this.createPhotoSwipeItemsFromImages(images),
      parseInt(index_currentSlide)
    );
  }

  initPhotoSwipeFromImageClick(event, target) {
    // Check if the current breakpoint is "pocket". If it is, return without doing anything.
    if (new Responsive().matchesBreakpoint("pocket")) {
      return;
    }

    // Create an array of images from the siblings of the target element.
    const images = [];
    const siblings = Array.from(target.parentElement.children);

    siblings.forEach((item) => {
      if (
        item.classList.contains("ProductSliderCell--Zoom") &&
        item.querySelector("img")
      ) {
        images.push(item.querySelector("img"));
      }
    });


    // Get the image position from the target element's data attribute.
    const imagePosition = parseInt(
      target
        .querySelector(".ProductSlider--Element")
        .getAttribute("data-image-position")
    );

    // Create the PhotoSwipe instance using the images and image position.
    this.createPhotoSwipeInstance(
      this.createPhotoSwipeItemsFromImages(images),
      imagePosition
    );
  }

  createPhotoSwipeItemsFromImages(images) {
    return images.map(function (image) {
      var maxWidth = parseInt(image.getAttribute("data-max-width")),
        maxHeight = parseInt(image.getAttribute("data-max-height")),
        maxDimension = new Responsive().matchesBreakpoint("phone")
          ? 1200
          : 2200,
        reduceFactor = 1.0;

      if (maxWidth >= maxHeight) {
        reduceFactor = Math.max(maxWidth / maxDimension, 1.0);
      } else {
        reduceFactor = Math.max(maxHeight / maxDimension, 1.0);
      }
      var requestedWidth = Math.floor(maxWidth / reduceFactor);
      var requestedHeight = Math.floor(maxHeight / reduceFactor);
      return {
        msrc: image.currentSrc || image.src,
        w: requestedWidth,
        h: requestedHeight,
        initialZoomLevel: 0.65,
        src: image.dataset.originalSrc,
      };
    });
  }

  createPhotoSwipeInstance(items, selectedImageIndex) {
    var _this = this;
    var photoswipeContainer = document.querySelector(".pswp");
    this.photoSwipeInstance = new PhotoSwipe(
      photoswipeContainer,
      false,
      items,
      {
        index: selectedImageIndex,
        showHideOpacity: true,
        showAnimationDuration: 500,
        loop: false,
        history: false,
        closeOnVerticalDrag: true,
        allowPanToNext: false,
        pinchToClose: false,
        errorMsg: '<p class="pswp__error-msg"></p>',
        scaleMode: "orig",
        getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
          if (isMouseClick) {
            return 1.35;
          } else {
            return item.initialZoomLevel < 0.7 ? 1 : 1.33;
          }
        },
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var allThumbnail = _this.element.querySelectorAll(
            ".mainSwiper .ProductSliderCell--Zoom img"
          ),
            thumbnail = allThumbnail[index],
            pageYScroll =
              window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        },
      }
    );

    this.photoSwipeInstance.listen(
      "beforeChange",
      this.onslideChanged.bind(this)
    );
    this.photoSwipeInstance.listen(
      "destroy",
      this.destroyPhotoSwipe.bind(this)
    );
    this.photoSwipeInstance.listen("doubleTap", this.onDoubleTap.bind(this));
    this.photoSwipeInstance.listen(
      "initialZoomIn",
      this.onInitialZoomIn.bind(this)
    );
    this.photoSwipeInstance.listen(
      "initialZoomOut",
      this.onInitialZoomOut.bind(this)
    );

    this.delegateRoot.on(
      "pswpTap",
      ".pswp__scroll-wrap",
      this.onSingleTap.bind(this)
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoSwipeInstance.close
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--prev",
      this.photoSwipeInstance.prev
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--next",
      this.photoSwipeInstance.next
    );
    this.photoSwipeInstance.listen("close", this.photoswiperClose.bind(this));
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.add("pswp-open-in-ios");
    }
    this.photoSwipeInstance.init();
  }

  onslideChanged() {
    if (this.photoSwipeInstance.getCurrentIndex() === 0) {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--prev")
        .setAttribute("disabled", "disabled");
    } else {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--prev")
        .removeAttribute("disabled");
    }

    if (
      this.photoSwipeInstance.getCurrentIndex() + 1 ===
      this.photoSwipeInstance.options.getNumItemsFn()
    ) {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--next")
        .setAttribute("disabled", "disabled");
    } else {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--next")
        .removeAttribute("disabled");
    }
  }

  onSingleTap(event) {
    if (!event.detail || event.detail.pointerType === "mouse") {
      if (event.target.classList.contains("pswp__img")) {
        this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint);
      }
    } else {
      if (event.target.classList.contains("pswp__button")) {
        return;
      }

      event.target
        .closest(".pswp")
        .querySelector(".pswp__ui")
        .classList.toggle("pswp__ui--hidden");
    }
  }

  onDoubleTap(point) {
    var initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel;

    if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
      this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
    } else {
      this.photoSwipeInstance.zoomTo(
        initialZoomLevel < 0.7 ? 1 : 1.33,
        point,
        333
      );
    }
  }

  onInitialZoomIn() {
    document.querySelector(".pswp__ui").classList.remove("pswp__ui--hidden");
  }
  onInitialZoomOut() {
    document.querySelector(".pswp__ui").classList.add("pswp__ui--hidden");
  }
  destroyPhotoSwipe() {
    this.delegateRoot.off("pswpTap");
    this.photoSwipeInstance = null;
  }
}

class RevolutionSelectbox {
  constructor(element, popover, additionalOverlay) {
    this.element = element;
    this.popover = popover;
    this.changeOverlay = additionalOverlay;
    this.domDelegate = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.dropdown = this.element.querySelector(".RevolutionSelectbox");
    this.isOpen = false;
    this.mainDropdown = this.element.querySelector(
      ".RevolutionSelectbox--Content"
    );
    this.v2 = false;
    this.stickyATC = document.querySelector('.ProductAction--Sticky');
    if (this.element.classList.contains('RevolutionSelectboxV2')) {
      this.selectedValue = this.element.querySelector('[checked]');
      if(this.selectedValue) this.selectedValue = this.selectedValue.value;
      if(!this.selectedValue) this.selectboxResetValue();
      this.titleText = this.element.querySelector('.RevolutionSelectbox--Title');
      this.reset = true;
      this.v2 = true;
    }

    if (this.mainDropdown) {
      this.mainDropdown.style.display = 'none';
      this.mainDropdownContent = this.element.querySelector(
        ".RevolutionSelectbox--InnerContent"
      );
      this.mainButton = this.element.querySelector(".RevolutionSelectbox--Button");

      this.connectedSelect = this.element.getAttribute("data-select");
      this.selectbox = this.element.querySelector(
        "[name=" + this.connectedSelect + "]"
      );
      if (this.selectbox == null) {
        this.selectbox = this.element.querySelector(
          "[name2=" + this.connectedSelect + "]"
        );
      }
      if (this.popover == true) {
        this.mainDropdown.classList.remove("RevolutionSelectbox--animation");
        this.mainDropdown.classList.add("PopoverContent");
        if (this.changeOverlay) {
          this.pageOverlayElement = document.querySelector(
            ".localizationOverlay"
          );
        } else {
          this.pageOverlayElement = document.querySelector(".pageOverlay");
        }
      }
      this.initSelectbox();
    }
    this.bindEvents();
  }

  bindEvents() {
    this.onClickOutsideListener = this.onClickOutside.bind(this);
    this.domDelegate.on(
      "click",
      "[data-action=toggle-selectbox]",
      this.toggleDropdown.bind(this)
    );

    this.domDelegate.on(
      "click",
      "[data-action=selectbox-submit]",
      this.selectboxSubmit.bind(this)
    );
    this.domDelegate.on(
      "keypress",
      "[data-action=selectbox-submit]",
      this.selectboxSubmit.bind(this)
    );

    this.domDelegate.on(
      "click",
      "[data-action=selectbox-change]",
      this.selectboxChange.bind(this)
    );
      this.selectboxCheckedListener = this.selectboxChange.bind(this);

    this.domDelegate.on(
      "click",
      "selectbox:checked",
      this.selectboxCheckedListener
    );

    if (this.v2) {
      const labelsOnHover = this.element.querySelectorAll("[data-action=selectbox-hover]");
      labelsOnHover.forEach(item => item.addEventListener("mouseenter", this.selectboxSetValue.bind(this)));
      labelsOnHover.forEach(item => item.addEventListener("mouseleave", this.selectboxResetValue.bind(this)))
    }

    this.delegateBody.on("menu:open", this.onClickOutside.bind(this));
    this.domDelegate.on("click", "body", this.onClickOutside.bind(this));
  }

  selectboxSetValue(e) {
    var value = e.target.getAttribute("data-value");
    if (this.v2) this.titleText.innerHTML = value;
    if (this.resetTimeout) clearTimeout(this.resetTimeout);
  }

  selectboxResetValue() {
    this.resetTimeout = setTimeout(() => {
      if (this.v2 && this.reset) this.selectedValue ? this.titleText.innerHTML  = this.selectedValue : this.titleText.innerHTML = window.variantStrings.unavailable;
    }, 175)
  }

  selectboxChange(e) {
    let eventTarget;
    e.detail && e.detail instanceof HTMLElement ? eventTarget = e.detail : eventTarget = event.target;
    this.mainButton = this.element.querySelector(".RevolutionSelectbox--Button");
    var value = eventTarget.getAttribute("data-value");
    var selectboxID = eventTarget.getAttribute("data-selectboxid");
    var innerContent = eventTarget.innerHTML;
    var selEl = this.element.querySelector("#" + selectboxID);
    if (selEl) {
      if (selEl.nodeName == "SELECT") {
        selEl.value = value;
        selEl.dispatchEvent(new Event("change"));
      } else {
        selEl
          .querySelector('[value="' + value + '"]')
          .setAttribute("checked", "true");
      }
    }

    if (this.v2) {
      if(eventTarget.nextElementSibling.classList.contains('SelectboxLabelUnderline')) {
        const inputs = document.querySelectorAll('.UnderlineSelectbox input');
        inputs.forEach(input => {input.checked = false; input.classList.remove('CheckBox');});
        eventTarget.checked = true;
  
        const titles = document.querySelectorAll(`.Product-Section .RevolutionSelectbox--Title.Underline`);
        titles.forEach(title => title.innerHTML = value);
      }
      if(eventTarget.nextElementSibling.classList.contains('SelectboxCircle')) {
        const inputs = document.querySelectorAll('.ColorSelectbox input');
        inputs.forEach(input => {input.checked = false; input.classList.remove('CheckBox');});
        eventTarget.checked = true;
        
        const titles = document.querySelectorAll(`.Product-Section .RevolutionSelectbox--Title.circleSwatch`);
        titles.forEach(title => title.innerHTML = value);
      }
      this.selectedValue = value;
      if (this.stickyATC) {
        const selectedSizeMobile = document.querySelector('.underlineVariantSticky');
        if (selectedSizeMobile && eventTarget.nextElementSibling.classList.contains('SelectboxLabelUnderline')) {
          selectedSizeMobile.innerHTML = value;
        } else {
          const color = eventTarget.nextElementSibling.style.backgroundColor;
          const selectedColorMobile = document.querySelector('.SelectboxCircleSticky');
          if (color && selectedColorMobile) {
            selectedColorMobile.style.backgroundColor = color;
          }
        }

        const allInputsOfThisKind = document.querySelectorAll(`input[data-value='${value}']`);
        allInputsOfThisKind.forEach(input => {
          if (input != eventTarget) {
            const parentElement = input.parentElement.parentElement;
            var checkedInput = parentElement.querySelector('input.CheckBox') || parentElement.querySelector('input[checked]')
            if (checkedInput) {
              checkedInput.checked ? checkedInput.checked = false : checkedInput.classList.remove('CheckBox');
            }
            input.checked = true;
            input.classList.add('CheckBox');
          }
        });
      }
      return;
    }

    this.mainButton.querySelector(".RevolutionSelectbox--Title").innerHTML =
      innerContent;

    if (this.element.classList.contains('dropdownSelector')) {
      this.element.querySelector('.RevolutionSelectbox--Item[disabled="true"]').removeAttribute('disabled');
      eventTarget.setAttribute('disabled', 'true');
    }
    this.closeDropdown(this.element);
  }

  onClickOutside(event) {
    const withinBoundaries = event.composedPath().includes(this.element);
    if (
      !withinBoundaries ||
      event.target.classList.contains("FiltersDesktopWrapper")
    ) {
      this.closeDropdown(this.element);
    }
  }

  selectboxSubmit(event) {
    if (event.key != "Enter" && event.key !== undefined) {
      return;
    }
    var value = event.target.getAttribute("data-value");
    var dataName = event.target.getAttribute("data-name");
    this.selectbox.value = value;
    this.closeDropdown(this.element);
    this.mainButton.querySelector(".RevolutionSelectbox--Title").innerHTML =
      dataName;
    this.selectbox.parentElement.submit();
  }

  initSelectbox() {
    const selectedItem = this.mainDropdown.querySelector(
      '[selected="selected"]'
    ),
      titleElement = this.element.querySelector(".RevolutionSelectbox--Title");

    if (selectedItem) {

      titleElement.innerHTML = selectedItem.getAttribute("data-name");
    }

    trapFocus(this.element);
    this.element.style.display = "block";
  }

  toggleDropdown(event, target) {
    event.preventDefault();

    if (this.isOpen) {
      this.closeDropdown(target);
    } else {
      this.openDropdown(target);
    }
  }

  openDropdown(target) {


    if(new Responsive().matchesBreakpoint('lap-and-up')){
          // Dispatch "close:search" and "menu:close" events on the element.
    this.element.dispatchEvent(
      new CustomEvent("close:search", { bubbles: true })
    );


    this.element.dispatchEvent(
      new CustomEvent("menu:close", { bubbles: true })
    );
    }


    // Find all siblings with class ".RevolutionSelectbox".
    const siblings = Array.from(
      target.parentElement.parentElement.children
    ).filter((item) => item.classList.contains("RevolutionSelectbox"));

    // Hide the dropdown content for all siblings.
    siblings.forEach((item) => {
      item
        .querySelector(".RevolutionSelectbox--Button")
        .setAttribute("aria-expanded", false);
      item
        .querySelector(".RevolutionSelectbox--Content")
        .setAttribute("aria-hidden", true);
      item.querySelector(".RevolutionSelectbox--Content").style.display =
        "none";
    });

    // If the dropdown is a popover, show the page overlay and disable body scrolling.
    if (this.popover) {
      this.pageOverlayElement.classList.add("is-visible");
      const announcementBar = document.body.querySelector("#shopify-section-section-announcement_bar");
      if (announcementBar) {
        announcementBar.style.zIndex = "3";
      }
      const header = document.body.querySelector("#shopify-section-main-header");
      if (header) {
        header.style.zIndex = "3"; 
      }
      this.pageOverlayElement.addEventListener(
        "click",
        this.onClickOutsideListener
      );
      const focus = this.element.querySelector("[data-scrollable]");
      bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
      document.body.classList.add("scrollLock");
      trapFocus(this.mainDropdown);
      if (
        document.querySelector("#mobileMenu").getAttribute("aria-expanded") ===
        "true"
      ) {
        const stickyNav = document.querySelector('.MobileMenu--StickyNav');
        var stickyNavHeight
        stickyNav ? stickyNavHeight = stickyNav.offsetHeight : stickyNavHeight = 0;
        this.mainDropdown.style.marginBottom = stickyNavHeight + 'px';
        
        document.querySelector(".Drawer--Wrapper").style.overflow = "visible";
      }
    }

    // Show the dropdown content for the target element and set its state to "expanded".
    const contentElement = target.parentElement.querySelector(
      ".RevolutionSelectbox--Content"
    );
    target.setAttribute("aria-expanded", "true");
    contentElement.style.display = "block";
    contentElement.style.height = `${contentElement.offsetHeight}px`;

    if (this.popover) {
      setTimeout(() => {
        contentElement.setAttribute("aria-hidden", "false");
      }, 20);
    } else {
      contentElement.setAttribute("aria-hidden", "false");
    }

    this.isOpen = true;
    window.addEventListener("click", this.onClickOutsideListener);
  }

  closeDropdown(target) {
    var closestDropdown = target.closest(".RevolutionSelectbox");
    if (closestDropdown === null) {
      var closestDropdown = target.querySelector(
        "[aria-expanded='true']"
      );
      if(closestDropdown) closestDropdown = closestDropdown.parentElement;
    }
    if(closestDropdown){
      closestDropdown
        .querySelector(".RevolutionSelectbox--Button")
        .setAttribute("aria-expanded", false);
      closestDropdown
        .querySelector(".RevolutionSelectbox--Content")
        .setAttribute("aria-hidden", true);
      setTimeout(() => {
        closestDropdown.querySelector(
          ".RevolutionSelectbox--Content"
        ).style.display = "none";
      }, 300);
    }

    if (this.popover == true) {
      const announcementBar = document.body.querySelector("#shopify-section-section-announcement_bar");
      if (announcementBar) {
        announcementBar.style.zIndex = "8";
      }
      const header = document.body.querySelector("#shopify-section-main-header");
      if (header) {
        header.style.zIndex = "8"; 
      }
      this.pageOverlayElement.classList.remove("is-visible");
      this.pageOverlayElement.removeEventListener(
        "click",
        this.onClickOutsideListener
      );

      const menuDrawer = document.querySelector("#mobileMenu");
      if (menuDrawer.getAttribute("aria-expanded") == "true") {
        document.querySelector(".Drawer--Wrapper").style.overflow = "auto";
      } else {
        document.body.classList.remove("scrollLock");
      }

        const focus = this.element.querySelector("[data-scrollable]");
        bodyScrollLock.enableBodyScroll(focus, bodyScrollLockOptions);
    
      
    }
    this.isOpen = false;
    removeTrapFocus(this.mainDropdownContent);
    window.removeEventListener("click", this.onClickOutsideListener);
  }
}

class Form {
  constructor() { }

  serialize(form) {
    function stringKey(key, value) {
      var beginBracket = key.lastIndexOf("[");

      if (beginBracket === -1) {
        var _hash = {};
        _hash[key] = value;
        return _hash;
      }

      var newKey = key.substr(0, beginBracket);
      var newValue = {};

      newValue[key.substring(beginBracket + 1, key.length - 1)] = value;

      return stringKey(newKey, newValue);
    }

    var hash = {};

    for (var i = 0, len = form.elements.length; i < len; i++) {
      var formElement = form.elements[i];

      if (formElement.name === "" || formElement.disabled) {
        continue;
      }

      if (
        formElement.name &&
        !formElement.disabled &&
        (formElement.checked ||
          /select|textarea/i.test(formElement.nodeName) ||
          /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(
            formElement.type
          ))
      ) {
        var stringKeys = stringKey(formElement.name, formElement.value);
        hash = this.extend(hash, stringKeys);
      }
    }

    return hash;
  }
  extend() {
    var extended = {},
      i = 0,
      _this = this;

    // Merge the object into the extended object
    var merge = function merge(obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          // If property is an object, merge properties
          if (Object.prototype.toString.call(obj[prop]) === "[object Object]") {
            extended[prop] = _this.extend(extended[prop], obj[prop]);
          } else {
            extended[prop] = obj[prop];
          }
        }
      }
    };

    // Loop through each object and conduct a merge
    for (; i < arguments.length; i++) {
      merge(arguments[i]);
    }

    return extended;
  }
}

class AddToCart {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action=add-to-cart]",
      this.addToCart.bind(this)
    );
  }

  addToCart() {
    var _this = this;
    event.preventDefault();
    var addToCartButton = event.target;
    this.pageLoader.style.width = 100 + "%";
    addToCartButton.setAttribute("disabled", "disabled");

    var formElement = event.target.closest("form");
    formElement.querySelector('[name="id"]').removeAttribute("disabled");
    var formHelper = new Form();
    const serialized = formHelper.serialize(formElement);
    fetch(window.routes.localeRootUrl + "/cart/add.js", {
      body: JSON.stringify(serialized),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {

        if (window.location.href.indexOf("cart") != -1) {
          location.reload();
          return;
        }

        if (window.theme.cartMode == 'page') {
          location.href = "/cart";
        }

        addToCartButton.removeAttribute("disabled");
        _this.element.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {
              variant: serialized.id,
              quantity: serialized.quantity,
            },
          })
        );

      } else {
        response.json().then(function (content) {
          if (_this.element.querySelector(".ProductForm--Error")) {
            _this.element
              .querySelector(".ProductForm--Error")
              .classList.add("visible");
            setTimeout(function () {
              _this.element
                .querySelector(".ProductForm--Error")
                .classList.remove("visible");
            }, 2500);
            _this.pageLoader.style.left = "unset";
            _this.pageLoader.style.right = 0 + "px";
            _this.pageLoader.style.width = 0 + "%";
            setTimeout(() => {
              _this.pageLoader.style.left = 0 + "px";
              _this.pageLoader.style.right = "unset";
            }, 550);
          } else {
            var errorMessageElement = document.createElement("span");
            errorMessageElement.className = "u-p4 accent";
            errorMessageElement.innerHTML = content["description"];
            addToCartButton.removeAttribute("disabled");
            addToCartButton.insertAdjacentElement(
              "afterend",
              errorMessageElement
            );
            setTimeout(function () {
              errorMessageElement.remove();
            }, 2500);
            _this.pageLoader.style.left = "unset";
            _this.pageLoader.style.right = 0 + "px";
            _this.pageLoader.style.width = 0 + "%";
            setTimeout(() => {
              _this.pageLoader.style.left = 0 + "px";
              _this.pageLoader.style.right = "unset";
            }, 550);
          }
        });
      }
    });
  }
}

/*GLOBAL FUNCTIONS */

function handleFirstTab(e) {
  if (e.keyCode === 9) {
    document.body.classList.add("user-is-tabbing");

    window.removeEventListener("keydown", handleFirstTab);
    window.addEventListener("mousedown", handleMouseDownOnce);
  }
}

function handleMouseDownOnce() {
  document.body.classList.remove("user-is-tabbing");

  window.removeEventListener("mousedown", handleMouseDownOnce);
  window.addEventListener("keydown", handleFirstTab);
}

window.addEventListener("keydown", handleFirstTab);

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe, .focusable"
    )
  );
}

const trapFocusHandlers = {};

const drawerPageInert = {
  counts: new Map(),

  getBackgroundTargets(drawerElement) {
    const targets = [];
    const maybeAdd = (element) => {
      if (!element || element === drawerElement || element.contains(drawerElement)) {
        return;
      }
      targets.push(element);
    };

    maybeAdd(document.getElementById("header"));
    maybeAdd(document.getElementById("shopify-section-section-announcement_bar"));
    maybeAdd(document.getElementById("shopify-section-main-footer"));

    const main = document.getElementById("MainContent");
    if (main) {
      Array.from(main.children).forEach((child) => {
        if (child === drawerElement || child.contains(drawerElement)) {
          return;
        }
        targets.push(child);
      });
    }

    return targets;
  },

  acquire(drawerElement) {
    const targets = this.getBackgroundTargets(drawerElement);
    targets.forEach((element) => {
      const count = (this.counts.get(element) || 0) + 1;
      this.counts.set(element, count);
      if (count === 1) {
        element.setAttribute("inert", "");
      }
    });
    return targets;
  },

  release(targets) {
    if (!targets) {
      return;
    }

    targets.forEach((element) => {
      const count = (this.counts.get(element) || 0) - 1;
      if (count <= 0) {
        this.counts.delete(element);
        element.removeAttribute("inert");
      } else {
        this.counts.set(element, count);
      }
    });
  },
};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  const preferred =
    elementToFocus &&
    elementToFocus !== container &&
    container.contains(elementToFocus)
      ? elementToFocus
      : first || elementToFocus;

  if (preferred) {
    const fromKeyboard = document.body.classList.contains("user-is-tabbing");
    preferred.focus(
      fromKeyboard ? undefined : { preventScroll: true, focusVisible: false }
    );
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class Responsive {
  constructor() {
    var _this = this;

    this.currentBreakpoint = this.getCurrentBreakpoint();

    window.addEventListener("resize", function () {
      var newBreakpoint = _this.getCurrentBreakpoint();

      if (_this.currentBreakpoint === newBreakpoint) {
        return;
      }

      document.dispatchEvent(
        new CustomEvent("breakpoint:changed", {
          detail: {
            previousBreakpoint: _this.currentBreakpoint,
            currentBreakpoint: newBreakpoint,
          },
        })
      );

      _this.currentBreakpoint = newBreakpoint;
    });
  }

  matchesBreakpoint(breakpoint) {
    switch (breakpoint) {
      case "phone":
        return window.matchMedia("screen and (max-width: 640px)").matches;

      case "tablet":
        return window.matchMedia(
          "screen and (min-width: 641px) and (max-width: 1024px)"
        ).matches;

      case "tablet-and-up":
        return window.matchMedia("screen and (min-width: 768px)").matches;

      case "pocket":
        return window.matchMedia("screen and (max-width: 1024px)").matches;

      case "lap-and-up":
        return window.matchMedia("screen and (min-width: 1025px)").matches;

      case "desk":
        return window.matchMedia("screen and (min-width: 1280px)").matches;
    }
  }
  getCurrentBreakpoint() {
    if (window.matchMedia("screen and (max-width: 640px)").matches) {
      return "phone";
    }

    if (
      window.matchMedia("screen and (min-width: 641px) and (max-width: 1024px)")
        .matches
    ) {
      return "tablet";
    }

    if (
      window.matchMedia(
        "screen and (min-width: 1008px) and (max-width: 1279px)"
      ).matches
    ) {
      return "lap";
    }

    if (window.matchMedia("screen and (min-width: 1280px)").matches) {
      return "desk";
    }
  }
}

class Dropdown {
  constructor() {
    this.domDelegate = new Delegate(document.body);
    this.breakpoint = new Responsive().getCurrentBreakpoint();
    this.allDropdowns = document.querySelectorAll(".Dropdown");

    this.bindEvents();
    this.initDropdownAccessibility();
    this.syncFooterDropdownAccessibility = this.syncFooterDropdownAccessibility.bind(this);
    window.addEventListener("resize", debounce(this.syncFooterDropdownAccessibility, 150));
  }

  initDropdownAccessibility() {
    document.querySelectorAll('.Dropdown--Content[aria-hidden="true"]').forEach((content) => {
      if (!this.isFooterDesktopPanel(content)) {
        content.setAttribute("inert", "");
      }
    });
    // Ensure always-visible content (aria-hidden="false") is never blocked
    document.querySelectorAll('.Dropdown--Content[aria-hidden="false"]').forEach((content) => {
      content.style.pointerEvents = "all";
    });
    this.syncFooterDropdownAccessibility();
  }

  isFooterDesktopPanel(content) {
    return content.closest(".footerWrapper") && window.matchMedia("(min-width: 1025px)").matches;
  }

  syncFooterDropdownAccessibility() {
    const footer = document.querySelector(".footerWrapper");
    if (!footer) {
      return;
    }

    const isDesktop = window.matchMedia("(min-width: 1025px)").matches;

    footer.querySelectorAll(".Dropdown").forEach((dropdown) => {
      const button = dropdown.querySelector(".Dropdown--Button");
      const content = dropdown.querySelector(".Dropdown--Content");
      if (!button || !content) {
        return;
      }

      if (isDesktop) {
        content.removeAttribute("inert");
        content.setAttribute("aria-hidden", "false");
        button.setAttribute("aria-expanded", "true");
        button.setAttribute("tabindex", "-1");
      } else {
        const isOpen = button.getAttribute("aria-expanded") === "true";
        button.removeAttribute("tabindex");
        content.setAttribute("aria-hidden", isOpen ? "false" : "true");
        if (isOpen) {
          content.removeAttribute("inert");
        } else {
          content.setAttribute("inert", "");
        }
      }
    });
  }

  setDropdownContentState(content, isOpen) {
    if (!content) {
      return;
    }

    content.setAttribute("aria-hidden", isOpen ? "false" : "true");
    if (isOpen) {
      content.removeAttribute("inert");
      return;
    }

    if (!this.isFooterDesktopPanel(content)) {
      content.setAttribute("inert", "");
    }
  }

  bindEvents() {
    // Bind event for general dropdown toggle
    this.domDelegate.on(
      "click",
      "[data-action=toggle-dropdown]",
      this.toggleDropdown.bind(this)
    );

    let selector;
    switch (this.breakpoint) {
      case "lap-and-up":
        // For lap-and-up breakpoint, bind event for desktop dropdown toggle
        selector = "[data-action=toggle-desktop-dropdown]";
        break;
      case "pocket":
        // For pocket breakpoint, bind event for mobile dropdown toggle
        selector = "[data-action=toggle-mobile-dropdown]";
        break;
        case "phone":
          // For pocket breakpoint, bind event for mobile dropdown toggle
          selector = "[data-action=toggle-mobile-dropdown]";
          break;
      default:
        // If no specific breakpoint, set selector as false to skip binding
        selector = false;
        break;
    }

    if (selector) {
      // Bind event for specific breakpoint dropdown toggle
      this.domDelegate.on("click", selector, this.toggleDropdown.bind(this));
    }
  }

  openDropdown(elem, target) {
    // Open the dropdown by setting appropriate attributes and performing animation
    this.allDropdowns.forEach(dropdown => {
      const innerDropdowns = dropdown.querySelectorAll('[data-action="toggle-dropdown"]');
      const isTargetInnerDropdown = [...innerDropdowns].some(inner => inner === target);

      if (!isTargetInnerDropdown && dropdown !== target.closest(".Dropdown") && dropdown.querySelector("[aria-expanded='true']")) {
        this.closeDropdown(dropdown);
      }
    });
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");
    DropdownButton.setAttribute("aria-expanded", "true");
    DropdownButton.style.pointerEvents = "none";
    setTimeout(() => DropdownButton.style.pointerEvents = "all", 250);

    this.setDropdownContentState(DropdownContent, true);
    new RevolutionAnimation(DropdownContent, "true").slideDown();
  }

  closeDropdown(elem) {
    // Close the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");

    new RevolutionAnimation(DropdownContent, "true").slideUp();
    DropdownButton.setAttribute("aria-expanded", false);
    DropdownButton.style.pointerEvents = "none";
    setTimeout(() => {
      this.setDropdownContentState(DropdownContent, false);
      DropdownButton.style.pointerEvents = "all";
    }, 250);
  }

  toggleDropdown(event, target) {
    event.preventDefault();
    const mainDropdown = target.closest(".Dropdown");
    const isOpen = target.getAttribute("aria-expanded") === "true";

    if (isOpen) {
      // If dropdown is open, close it
      this.closeDropdown(mainDropdown, target);
    } else {
      // If dropdown is closed, open it
      this.openDropdown(mainDropdown, target);
    }
  }
}

new Dropdown();

class RevolutionSwiper {
  constructor(element, additionalSwiper) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.thumb = additionalSwiper;
    this.initialConfig = JSON.parse(
      element.getAttribute("data-swiper-settings")
    );

    if (additionalSwiper) {
      this.initialConfigThumbs = JSON.parse(
        additionalSwiper.getAttribute("data-swiper-thumb-settings")
      );
    }
    this.options = options;
    this.build();
  }

  selectCell(index) {
    this.swiperElement.slideTo(index);
  }

  resize() {
    this.swiperElement.resize();
  }

  build() {
    var _this = this,
      configThumb = this.initialConfigThumbs;
    if (configThumb != null) {
      this.thumbSwiper = new Swiper(this.thumb, configThumb);
      this.initialConfig.thumbs["swiper"] = this.thumbSwiper;
    }

    this.swiperElement = new Swiper(this.element, this.initialConfig);
    this.selectedIndex = this.swiperElement.activeIndex;

    this.swiperElement.on("slideChange", function () {
      _this.element.dispatchEvent(
        new CustomEvent("swiper:slide-changed", {
          bubbles: true,
          detail: {
            currentIndex: _this.swiperElement.activeIndex,
            element: _this.swiperElement.el[0],
          },
        })
      );
    });
  }
}

class Drawer {
  constructor(element) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.pageOverlayElement = document.querySelector(".pageOverlay");

  
    this.onOpen = options["onOpen"] || function () { };
    this.onClose = options["onClose"] || function () { };
    this.isOpen = false;

    this.bindEvents();
    this.changeShowAnim();
  }

  bindEvents() {
    this.delegateBody.on(
      "click",
      '[data-action="open-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.openDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="close-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.closeDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="toggle-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.toggleDrawer.bind(this)
    );
    this._openListener = this.openDrawer.bind(this);
    this._closeListener = this.closeDrawer.bind(this);
    this.calculateMaxHeightListener = this.maxHeight.bind(this);
    window.addEventListener("resize", this.calculateMaxHeightListener);


    this.delegateBody.on("cart-drawer:close-other", this._closeListener);
  }

  maxHeight(event) {
    this.setRootHeight();
    const id = this.element.getAttribute("id");
  
    if (id == "quantityDrawer") {
      return;
    }
  
    if (id == "cart" || id == "favoritesDrawer") {
      this.adjustCartDrawerHeight();
    } else if (id == "sidebarDrawer") {
      this.element.style.height = window.innerHeight + "px";
    } else if (event && event.type != 'resize') {
      this.adjustSpecialDrawerHeight(id);
    } else {
      this.adjustFilterBarHeight();
    }
  
    if (id == "mobileMenu") {
      this.adjustMobileMenuHeight();
    } else if (id == 'helpDrawer') {
      this.adjustHelpDrawerHeight();
    }
  
    this.changeShowAnim();
  }
  
  setRootHeight() {
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  }
  
  adjustCartDrawerHeight() {
    this.element.style.height = window.innerHeight + "px";
    const footer = this.element.querySelector(".CartDrawer--Footer");
    const footerHeight = footer ? footer.offsetHeight : 0;
  
    const cartHeader = this.element.querySelector(".CartHeader");
    const cartHeaderHeight = cartHeader ? cartHeader.offsetHeight : 0;
    document.documentElement.style.setProperty("--cartHeader-height", cartHeaderHeight + "px");
  
    const itemWrapper = this.element.querySelector(".CartItems--Wrapper");
    if (itemWrapper) {
      itemWrapper.style.height =
        window.innerHeight - footerHeight - cartHeaderHeight + "px";
    }
  }
  
  adjustSpecialDrawerHeight(id) {
    const headerElem = document.querySelector(".header");
    const headerHeight = headerElem.offsetHeight;
    const annBar = document.querySelector("#shopify-section-section-announcement_bar");
    const annBarHeight = annBar ? annBar.offsetHeight : 0;
    const stickyNav = document.querySelector('.MobileMenu--StickyNav');
    const stickyNavHeight = stickyNav ? stickyNav.offsetHeight : 0;
  
    if (
      (event.target.getAttribute('data-drawer') === 'special' && (id == 'helpDrawer' || id == 'mobileMenu')) ||
      this.mobileMenuOpen
    ) {
      if (id != 'mobileMenu') {
        this.element.style.height = window.innerHeight - stickyNavHeight - headerHeight - annBarHeight + "px";
      } else {
        this.element.style.height = window.scrollY > 0 ?
          window.innerHeight - headerHeight + 2 + "px" :
          window.innerHeight - headerHeight - annBarHeight + 2 + "px";
      }
    }
  }
  
  adjustFilterBarHeight() {
    const filterBar = document.querySelector(".FilterBar");
    const breakpoint = new Responsive().getCurrentBreakpoint();
  
    if (filterBar !== null && breakpoint == "phone") {
      this.element.style.height = window.innerHeight + "px";
    }
  }
  
  adjustMobileMenuHeight() {
    const headerElem = document.querySelector(".header");
    const headerHeight = headerElem.offsetHeight;
    const annBar = document.querySelector("#shopify-section-section-announcement_bar");
    const annBarHeight = annBar ? annBar.offsetHeight : 0;
    const stickyNav = document.querySelector('.MobileMenu--StickyNav');

  
    const visibleHeaderHeight = window.visibleHeader;
  
    this.element.style.height = window.scrollY > 1 ?
      window.innerHeight - visibleHeaderHeight + 2 + "px" :
      window.innerHeight - visibleHeaderHeight - annBarHeight + 2 + "px";
  
    if (stickyNav) {
      document.documentElement.style.setProperty('--helper-menu', stickyNav.offsetHeight + 'px');
    }
  }
  
  adjustHelpDrawerHeight() {
    const headerElem = document.querySelector(".header");
    const headerHeight = headerElem.offsetHeight;
    const annBar = document.querySelector("#shopify-section-section-announcement_bar");
    const annBarHeight = annBar ? annBar.offsetHeight : 0;
    const stickyNav = document.querySelector('.MobileMenu--StickyNav');
    const stickyNavHeight = stickyNav ? stickyNav.offsetHeight : 0;
  
    const visibleHeaderHeight = window.visibleHeader;

    this.element.style.height = window.scrollY > 0 ?
      window.innerHeight - visibleHeaderHeight - stickyNavHeight + "px" :
      window.innerHeight - visibleHeaderHeight - annBarHeight - stickyNavHeight + "px";
  
    if (stickyNav) {
      document.documentElement.style.setProperty('--helper-menu', stickyNav.offsetHeight + 'px');
    }
  }
  

  changeShowAnim() {
    if (this.element.id == 'sizeGuide') {
      if (window.innerWidth <= 1024) {
        this.element.classList.remove('Drawer--Right');
        this.element.classList.add('Drawer--Bottom');
      } else {
        this.element.classList.remove('Drawer--Bottom');
        this.element.classList.add('Drawer--Right');
      }
    }
  }

  toggleDrawer(event) {
    event.preventDefault();
    this.isOpen ? this.closeDrawer(event) : this.openDrawer(event);
  }

  updateDrawerTriggers(drawerId, isExpanded) {
    document
      .querySelectorAll(
        `[data-toggle-id="${drawerId}"][data-action*="drawer"], [aria-controls="${drawerId}"][data-action*="drawer"]`
      )
      .forEach((trigger) => {
        trigger.setAttribute("aria-expanded", isExpanded ? "true" : "false");
      });
  }

  setPageInert() {
    this.inertElements = drawerPageInert.acquire(this.element);
  }

  clearPageInert() {
    drawerPageInert.release(this.inertElements);
    this.inertElements = [];
  }

  rememberActiveTrigger(drawerId, triggerEvent) {
    if (triggerEvent && triggerEvent.target) {
      this.lastActiveTrigger = triggerEvent.target.closest(
        `[data-toggle-id="${drawerId}"], [aria-controls="${drawerId}"]`
      );
    }

    if (!this.lastActiveTrigger) {
      this.lastActiveTrigger =
        document.getElementById("header-cart-link") ||
        document.querySelector(`[data-toggle-id="${drawerId}"]`);
    }
  }

  bindEscapeKey() {
    this.unbindEscapeKey();
    this._escapeListener = (keydownEvent) => {
      if (keydownEvent.key !== "Escape" || !this.isOpen) {
        return;
      }

      keydownEvent.preventDefault();
      // Close without the keydown event: KeyboardEvent.detail is a number and
      // closeDrawer's event.detail checks are only meant for custom events.
      this.closeDrawer();
    };

    document.addEventListener("keydown", this._escapeListener); // delegate-exempt: global Escape closes active drawer
  }

  unbindEscapeKey() {
    if (!this._escapeListener) {
      return;
    }

    document.removeEventListener("keydown", this._escapeListener);
    this._escapeListener = null;
  }

  updateDrawerAccessibility(isExpanded) {
    const drawerId = this.element.getAttribute("id");

    this.element.setAttribute("aria-expanded", isExpanded ? "true" : "false");
    this.element.setAttribute("aria-hidden", isExpanded ? "false" : "true");
    this.updateDrawerTriggers(drawerId, isExpanded);

    if (drawerId === "mobileMenu") {
      const toggle = document.getElementById("mobile-menu-toggle");
      if (toggle) {
        const label = isExpanded ? toggle.dataset.labelClose : toggle.dataset.labelOpen;
        if (label) {
          toggle.setAttribute("aria-label", label);
        }
      }
    }
  }

  openDrawer(event) {
    this.maxHeight(event);
    var drawerId = this.element.getAttribute("id");
    this.element.dispatchEvent(
      new CustomEvent("close:search", { bubbles: true })
    );

    if (drawerId == "mobileMenu") {
      this.element.addEventListener("touchmove", this.calculateMaxHeightListener);
      this.element.dispatchEvent(
        new CustomEvent("header:transparent", { bubbles: true, detail: false })
      );
      this.mobileMenuOpen = true;
    }
    if (drawerId == "cart") {
      this.element.dispatchEvent(
        new CustomEvent("cart-drawer:open", { bubbles: true })
      );

      if (this.element.querySelector(".emptyItem--Text")) {
        this.element.querySelector(".emptyItem--Text").style.display = "flex";
      }

      setTimeout(() => {
        var count = window.theme.cartCount;
        var options = JSON.parse(this.element.getAttribute("data-settings"));
      }, 200);
    }
    if (this.isOpen) {
      return;
    }

    if (event) {
      if (event.target.getAttribute('data-drawer') !== 'special' || !event.target.hasAttribute('data-drawer') || drawerId == 'accountDrawer') {
        this.element.dispatchEvent(
          new CustomEvent("cart-drawer:close-other", { bubbles: true })
        );
      }
      else if (event.target.getAttribute('data-drawer') === 'special' && drawerId != 'accountDrawer') {
        this.element.dispatchEvent(
          new CustomEvent("cart-drawer:close-other", { bubbles: true, detail: drawerId })
        );
      }
    } else {
      this.element.dispatchEvent(
        new CustomEvent("cart-drawer:close-other", { bubbles: true })
      );
    }


    this.maxHeight(event);

    if (drawerId == "sidebarDrawer") {
      if (document.querySelector(".SidebarDrawer__Close")) {
        document.querySelector(".SidebarDrawer__Close").style.display = "block";
      }


      this.element.dispatchEvent(
        new CustomEvent("sidebar-drawer:open", {
          bubbles: true,
        })
      );
    } else if (drawerId == "favoritesDrawer") {
      this.element.dispatchEvent(
        new CustomEvent("favorite-product:open", {
          bubbles: true,
        })
      );
    }

    this.updateDrawerAccessibility(true);
    if (drawerId != "mobileMenu" && drawerId != "helpDrawer") {
      this.pageOverlayElement.classList.add("is-visible");
    }
    if (drawerId != "quantityDrawer") {
      this.setPageInert();
    }
    this.pageOverlayElement.addEventListener("click", this._closeListener);

    var focus = this.element.querySelectorAll("[data-scrollable]");
    focus.forEach((item) => {
      bodyScrollLock.disableBodyScroll(item, bodyScrollLockOptions);
    });
    document.body.classList.add("scrollLock");
    this.isOpen = true;
    this.rememberActiveTrigger(drawerId, event);
    this.bindEscapeKey();
    const initialFocus =
      this.element.querySelector('[data-action="close-drawer"]') || this.element;
    setTimeout(() => {
      trapFocus(this.element, initialFocus);
    }, 400);
    this.onOpen();
    return false;
  }

  closeDrawer(event) {
    if (!this.isOpen) {
      return;
    }

    var drawerId = this.element.getAttribute("id");
    if (event) {
      // Only custom drawer events use string `detail` for coordination.
      // Native click/keyboard events must not early-return here.
      if (event instanceof CustomEvent && typeof event.detail === "string") {
        if (drawerId == event.detail || drawerId == "mobileMenu") return;
      }

      if (typeof event.preventDefault === "function") {
        event.preventDefault();
      }
    }

    if (drawerId == "mobileMenu") {
      this.element.removeEventListener("touchmove", this.calculateMaxHeightListener);
      this.mobileMenuOpen = false;
      this.element.dispatchEvent(
        new CustomEvent("header:transparent", { bubbles: true, detail: true })
      );
    }
    if (drawerId != 'helpDrawer') {
      document.body.classList.remove("scrollLock");
      bodyScrollLock.clearAllBodyScrollLocks();
    }
    if (drawerId == "cart") {
      var options = JSON.parse(this.element.getAttribute("data-settings"));
    }
    this.updateDrawerAccessibility(false);

    this.unbindEscapeKey();
    this.clearPageInert();

    if (
      this.element.classList.contains("sizeDrawer_Wrapper") == true &&
      document.body.querySelector("#cart").getAttribute("aria-expanded") ==
      "true"
    ) {
      removeTrapFocus(this.lastActiveTrigger);
      this.lastActiveTrigger = null;
      this.isOpen = false;
      this.onClose();
      return;
    }

    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener("click", this._closeListener);
    removeTrapFocus(this.lastActiveTrigger);
    this.lastActiveTrigger = null;
    this.closeAnimation(this.element);
    this.isOpen = false;
    this.onClose();
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

class RevolutionAnimation {
  constructor(element, directAnimation) {
    this.element = element;
    if (!directAnimation) {
      this.intersectionObserver = [];
      this.integer = 0;
      var contentToAnimate = document.querySelectorAll("[data-animation]");
      contentToAnimate.forEach((item, i) => {
        this.animateElement(item, i);
        this.integer = this.integer + 1;
      });

      // Listen for changes to the DOM and animate any new elements
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const newContentToAnimate =
                node.querySelectorAll("[data-animation]");

              newContentToAnimate.forEach((item, i) => {
                this.animateElement(item, this.integer);
                this.integer = this.integer + 1;
              });
            }
          });
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  slideUp() {
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.offsetHeight;
    this.element.style.height = 0;
  }

  slideDown() {
    const computedHeight = getComputedStyle(this.element).height;
    if (this.element.style.height === "auto" || computedHeight === "auto") {
      this.element.style.pointerEvents = "all";
      return;
    }
    this.element.style.pointerEvents = "none";
    var _this = this;
    const targetHeight = this.element.scrollHeight;
    this.element.style.height = targetHeight + "px";
    this.element.setAttribute("aria-hidden", false);
    var transitionEnded = function transitionEnded(event) {
      _this.element.style.pointerEvents = "all";
      if (event.propertyName === "height") {
        _this.element.style.height = "auto";
        _this.element.removeEventListener("transitionend", transitionEnded);
      }
    };

    this.element.addEventListener("transitionend", transitionEnded);

    // Fallback: if transitionend never fires (e.g. already at target height), restore pointer-events
    setTimeout(() => {
      if (_this.element.style.pointerEvents === "none") {
        _this.element.style.pointerEvents = "all";
        _this.element.removeEventListener("transitionend", transitionEnded);
      }
    }, 400);
  }

  // A function to animate a list of elements by scaling them out
  elementScaleOut(elements) {
    // Get the animation duration and delay from the theme settings
    const animationDuration = window.theme.animationDuration * 2;
    const animationDelay = window.theme.animationBetweenElements;

    // Loop through each element in the list
    elements.forEach((element, index) => {
      // Check if the element has already been loaded
      if (element.hasAttribute("data-loaded")) {
        // If so, skip this element
        return;
      }

      // Mark the element as loaded to prevent duplicate animations
      element.setAttribute("data-loaded", true);

      // Define the animation keyframes
      const keyframes = [
        { transform: "scale(104%)", opacity: "0" },
        { transform: "scale(100%)", opacity: "1" },
      ];

      // Define the animation options
      const animationOptions = {
        duration: animationDuration,
        fill: "forwards",
      };

      // Schedule the animation with a delay based on the element's position in the list
      setTimeout(() => {
        element.animate(keyframes, animationOptions);
      }, animationDelay * index);
    });
  }

  elementScaleIn(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "scale(96%)", opacity: "0" },
          { transform: "scale(100%)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration * 2,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromTop(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateY(-30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromBottom(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateY(30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromRight(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromLeft(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(-30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromRightBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromLeftBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(-120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  animateElement(animatedItem, index) {
    const options = {
      integer: index,
      type: animatedItem.dataset.animation,
    };

    if (this.intersectionObserver[index]) {
      this.intersectionObserver[index].disconnect();
    }

    this.intersectionObserver[index] = new IntersectionObserver(
      (results) => {
        const integer = options.integer;
        const elements = [];


        // Iterate over the IntersectionObserverEntry objects in the results array.
        results.forEach((result) => {
          // Check if the target element is intersecting the root element or if its intersection ratio is greater than 0.
          if (result.isIntersecting || result.intersectionRatio > 0) {
            // Add the target element to the elements array.
            elements.push(result.target);
            // Unobserve the target element.
            this.intersectionObserver[integer].unobserve(result.target);
          }
        });


        // If there are no elements to reveal, return.
        if (elements.length === 0) {
          return;
        }

        // An object that maps each animation type to the corresponding animation function.
        const animations = {
          elementFromTop: "elementFromTop",
          elementFromBottom: "elementFromBottom",
          elementFromRight: "elementFromRight",
          elementFromLeft: "elementFromLeft",
          elementFromLeftBig: "elementFromLeftBig",
          elementFromRightBig: "elementFromRightBig",
          elementScaleIn: "elementScaleIn",
          elementScaleOut: "elementScaleOut",
        };

        // Get the animation function corresponding to the type from the animations object.
        const animation = animations[options.type];
        // If the animation function exists, call it with the elements array.
        if (animation) {
          this[animation](elements);
        }
      },
      { threshold: 0.25 }
    );

    if (animatedItem.classList.contains("animatedContent")) {
      this.intersectionObserver[index].observe(animatedItem);
    }

    animatedItem.querySelectorAll(".animatedContent").forEach((item) => {
      this.intersectionObserver[index].observe(item);
    });
  }
}

if (window.theme.enableAnimations) {
  document.addEventListener("DOMContentLoaded", function () {
    new RevolutionAnimation();
  });
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.input = this.querySelector("input");
    this.changeEvent = new Event("quantity:changed", { bubbles: true });
    this.options = JSON.parse(this.element.getAttribute("data-settings"));

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    if (this.options["noVariants"] == "true") {
      this.toggleAddButton();
    }
  }

  toggleAddButton() {
    let quantity = "";
    const addButton = document.querySelector(".ProductPage--ATC"),
      addButtonInner = addButton.querySelector(".SelfAlign"),
      quantityEl = document.querySelector(".QuantitySelector__ProductQuantity");
    const stickyAddButton = document.querySelector(".ProductAction--StickyButton"),
      stickyAddButtonInner = stickyAddButton.querySelector(".SelfAlign");

    if (quantityEl) {
      quantity = quantityEl.value();
    }
    if (window.variantInfo.show_icon) {
      var buySvg =
        '<svg class="Svg Svg--shopping_cart mr-m" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M25.31 5.19547C25.1687 5.02127 24.9568 4.91946 24.7325 4.91797H9.11751L9.60501 6.41797H23.75L21.7475 15.418H10.4975L7.07001 4.56547C6.99476 4.33174 6.80986 4.14965 6.57501 4.07797L3.50001 3.13297C3.24278 3.05393 2.96292 3.11812 2.76584 3.30137C2.56877 3.48461 2.48443 3.75907 2.54459 4.02137C2.60476 4.28366 2.80028 4.49393 3.05751 4.57297L5.75001 5.39797L9.19251 16.273L7.96251 17.278L7.86501 17.3755C7.2374 18.0987 7.21221 19.1659 7.80501 19.918C8.21952 20.4221 8.84817 20.7002 9.50001 20.668H22.0175C22.4317 20.668 22.7675 20.3322 22.7675 19.918C22.7675 19.5038 22.4317 19.168 22.0175 19.168H9.38001C9.20436 19.162 9.0446 19.0646 8.95873 18.9113C8.87286 18.7579 8.87334 18.5709 8.96001 18.418L10.7675 16.918H22.3475C22.705 16.9267 23.0189 16.6818 23.0975 16.333L25.475 5.83297C25.5212 5.6064 25.4603 5.37117 25.31 5.19547ZM20.75 25.168C21.682 25.168 22.4375 24.4125 22.4375 23.4805C22.4375 22.5485 21.682 21.793 20.75 21.793C19.818 21.793 19.0625 22.5485 19.0625 23.4805C19.0625 24.4125 19.818 25.168 20.75 25.168ZM12.185 23.4805C12.185 24.4125 11.4295 25.168 10.4975 25.168C9.56553 25.168 8.81001 24.4125 8.81001 23.4805C8.81001 22.5485 9.56553 21.793 10.4975 21.793C11.4295 21.793 12.185 22.5485 12.185 23.4805Z" fill="#121212"></path></svg>';
    } else {
      var buySvg = "";
    }


    if (!addButton) return;
    if (!quantity) {
      quantity = 1;
    }

    addButton.removeAttribute("disabled");
    addButton.classList.remove("ProductCard--Sold__Out");
    if (stickyAddButton && stickyAddButtonInner) {
      stickyAddButton.setAttribute("disabled", "disabled");
      stickyAddButton.classList.add("ProductCard--Sold__Out");
    }
    if (window.variantInfo.show_price) {
      var priceElement =
        "<span class='u-pb1 ml-s'>" +
        Shopify.formatMoney(
          this.options["price"] * quantity,
          window.theme.moneyFormat
        );
      +"</span>";
    } else {
      var priceElement = "";
    }
    addButtonInner.innerHTML =
      buySvg + window.variantStrings.addToCart + priceElement;

    if (stickyAddButton && stickyAddButtonInner) stickyAddButtonInner.innerHTML = buySvg + window.variantStrings.addToCart + priceElement;
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ProductForm extends HTMLElement {
  constructor() {
    super();
    new AddToCart(this);
  }
}

customElements.define("product-form", ProductForm);

class Countdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    const counterWrapper = this.element.querySelector('.component-countDownWrapper');

    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    let counterString = this.options['countdownString'];
    counterString = counterString.replace('{countdown}','<span class="u-h5 component-countDown">00:00:00</span>');
    counterWrapper.innerHTML = counterString;

    const dateNow = new Date();
    const todaysDay = dateNow.getDay();

    const countdownDay = this.options.countdownDays;


    this.dayDifference = countdownDay - todaysDay;
    
      if (this.dayDifference < 0) {
        // If the countdown day is earlier in the week, add 7 to the difference
        this.dayDifference += 7;
      }

    this.counter = this.element.querySelector(".component-countDown");
    setInterval(this.countDown.bind(this), 1000);
  }

  countDown() {
    const dateNow = new Date();
    const currentHours = dateNow.getHours();
    const currentMinutes = dateNow.getMinutes();
    let countDate = new Date(`March 3, 2099 ${this.options.countdownTime}`);

    if (this.options['countdownType'] == 'to_date'){
       countDate = new Date(this.options.countdownDate);
    }
    
 

    const difference = countDate - dateNow;

    const seconds = 1000;
    const minutes = seconds * 60;
    const hours = minutes * 60;
    const days = hours * 24;
  

    let textDays = Math.floor(difference / (1000 * 60 * 60 * 24));
    let textHours = Math.floor((difference % days) / hours);
    let textMinutes = Math.floor((difference % hours) / minutes);
    let textSeconds = Math.floor((difference % minutes) / seconds);


    const [targetHours, targetMinutes] = this.options.countdownTime.split(':').map(Number);
    if (targetHours < currentHours && this.options['countdownType'] == 'reccuring' || (targetHours === currentHours && targetMinutes <= currentMinutes) && this.options['countdownType'] == 'reccuring') {
      textDays = this.dayDifference - 1;
    } else if(this.options['countdownType'] == 'reccuring') {
      textDays = this.dayDifference;
    }


    const displayHours = textHours;
    const formatHours = displayHours < 10 ? `0${displayHours}` : displayHours;
    const formatMinutes = textMinutes < 10 ? `0${textMinutes}` : textMinutes;
    const formatSeconds = textSeconds < 10 ? `0${textSeconds}` : textSeconds;

    if (textDays > 0) {
      this.counter.innerText = `${textDays}d ${formatHours}:${formatMinutes}:${formatSeconds}`;
    } else {
      this.counter.innerText = `${formatHours}:${formatMinutes}:${formatSeconds}`;
    }
  }
}

customElements.define("countdown-element", Countdown);




class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.sidebarDrawer = new Drawer(this.element);
    this.loader = this.element.querySelector(".itemLoader");
    this.cartCount = document.querySelector(".CartCount");
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.breakpoint = new Responsive().getCurrentBreakpoint();
    this.changeEvent = new Event("quantity:changed", { bubbles: true });
    window.theme.cartCount > 0 ? this.cartCount.classList.add('u-s4') : this.cartCount.classList.remove('u-s4');
    this.updateHeaderCartAccessibility(window.theme.cartCount);
    this.recommendationsLoaded = false;
    new AddToCart(this.element);
    if (window.theme.enableAnimations) {
      new RevolutionAnimation(this.element);
    }
    this.bindEvents();
  }
  onUnload() {
    this.delegateElement.off();
    document.removeEventListener("product:added", this.onProductAddedListener);
  }
  bindEvents() {
    if (window.theme.listener == "false") {
      this.onProductAddedListener = this.onProductAdded.bind(this);
      document.addEventListener("cart-drawer:open", this.onOpen.bind(this));
      document.addEventListener("product:added", this.onProductAddedListener);
      this.delegateElement.on(
        "click",
        '[data-action="update-item-quantity"], [data-action="remove-item"]',
        this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
        "change",
        '[data-action="update-change-quantity"]',
        this.updateItemQuantity.bind(this)
      );

      this.delegateElement.on(
        "keydown",
        '[data-action="update-change-quantity"]',
        this.preventEvent.bind(this)
      );

      this.delegateElement.on(
        "quantity:changed",
        ".QuantitySelector__CurrentQuantity",
        this.updateItemQuantity.bind(this)
      );
      document.addEventListener(
        "cart:rerender",
        this.renderCart.bind(this)
      );

      window.theme.listener = "true";
    }
  }

  preventEvent(event, target) {
    if (event.which === 13 || event.keyCode === 13) {
      event.preventDefault();
      this.updateItemQuantity(event, target);
    }

  }

  onOpen() {
    // Get the value of the aria-expanded attribute.
    const isExpanded = this.element.getAttribute("aria-expanded") === "true";

    // Early exit if the drawer is already expanded.
    if (isExpanded) {
      return;
    }

    // Calculate the height of the cart header and free shipping elements.
    const cartHeader = document.querySelector(".CartHeader");

    const cartHeaderHeight = cartHeader ? cartHeader.offsetHeight : 0;

    let totalHeight = cartHeaderHeight;

    // Set the height of the cart header using a CSS variable.
    /* if(window.theme.cartCount > 0 ){
       totalHeight = cartHeaderHeight;
    }  */
    document.documentElement.style.setProperty("--cartHeader-height", totalHeight + "px");
    // Load recommendations if the option is enabled.
    if (this.options.showRecommendations) {
      this.loadRecommendations();
    }
  }

  updateItemQuantity(event, target) {
    if (target.disabled || target.getAttribute("aria-disabled") === "true") {
      event.preventDefault();
      return;
    }

    event.preventDefault();
    target
      .closest(".cartItem")
      .querySelector(".itemLoader")
      .classList.add("is-visible");
    var _this = this;

    var quantity = null;
    if (target.tagName === "INPUT") {
      quantity = parseInt(Math.max(parseInt(target.value) || 0, 0));
    } else {
      quantity = parseInt(target.getAttribute("data-quantity"));
    }


    fetch(window.routes.localeRootUrl + "/cart/change.js", {
      body: JSON.stringify({
        id: target.getAttribute("data-line-id"),
        quantity: quantity,
      }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function () {
      _this.renderCart(target.getAttribute("data-id"), true);
    });
  }

  onProductAdded() {
    var _this = this;
    this.firstProductAdded = false;
    this.renderCart().then(function () {
      _this.sidebarDrawer.openDrawer();
    });
  }

  renderCart(lineNumber, quantityChange) {
    this.pageLoader.style.width = 100 + "%";
    let skipEvent = false;
    if (event && event.type == 'cart:rerender') {
      lineNumber = 'CartItem-' + event.detail.lineItem;
      quantityChange = event.detail.quantityChange;
      skipEvent = true;
    }
    var _this = this;
    return fetch(window.routes.localeRootUrl + "/?section_id=cart_drawer", {
      credentials: "same-origin",
      method: "GET",
    }).then(function (content) {
      content.text().then(function (html) {
        _this.replaceContent(html, lineNumber, quantityChange, skipEvent);
      });
    });
  }

  updateHeaderCartAccessibility(count, announce = false) {
    const cartLink = document.getElementById("header-cart-link");
    const liveRegion = document.getElementById("header-cart-live-region");
    const parsedCount = parseInt(count, 10) || 0;

    if (cartLink && window.cartStrings) {
      let label = window.cartStrings.cartEmpty;
      if (parsedCount === 1) {
        label = window.cartStrings.cartWithCountOne.replace("%count%", parsedCount);
      } else if (parsedCount > 1) {
        label = window.cartStrings.cartWithCountOther.replace("%count%", parsedCount);
      }
      cartLink.setAttribute("aria-label", label);
    }

    if (announce && liveRegion && window.cartStrings) {
      let announcement = window.cartStrings.cartUpdatedZero;
      if (parsedCount === 1) {
        announcement = window.cartStrings.cartUpdatedOne.replace("%count%", parsedCount);
      } else if (parsedCount > 1) {
        announcement = window.cartStrings.cartUpdatedOther.replace("%count%", parsedCount);
      }

      liveRegion.textContent = "";
      requestAnimationFrame(() => {
        liveRegion.textContent = announcement;
      });
    }
  }

  replaceContent(html, lineNumber, quantityChange, skipEvent) {
    var _this = this;
    this.pageLoader.style.left = "unset";
    this.pageLoader.style.right = 0 + "px";
    this.pageLoader.style.width = 0 + "%";
    setTimeout(() => {
      this.pageLoader.style.left = 0 + "px";
      this.pageLoader.style.right = "unset";
    }, 550);
    var tempElement = document.createElement("div");
    tempElement.innerHTML = html;

    this.tempOptions = JSON.parse(
      tempElement.querySelector("#cart").getAttribute("data-settings")
    );

    if (this.firstProductAdded) document.dispatchEvent(_this.changeEvent);
    this.firstProductAdded = true;

    var number = this.tempOptions["itemCount"];
    this.cartCount.innerHTML = `(${number})`;
    if (number > 0) {
      document.querySelector('.fullHeaderIcon').setAttribute('aria-hidden', 'false');
      document.querySelector('.emptyHeaderIcon').setAttribute('aria-hidden', 'true');
      this.cartCount.classList.add('u-s4');
    } else {
      document.querySelector('.fullHeaderIcon').setAttribute('aria-hidden', 'true');
      document.querySelector('.emptyHeaderIcon').setAttribute('aria-hidden', 'false');
      this.cartCount.classList.remove('u-s4');
    }
    window.theme.cartCount = parseInt(number);
    this.updateHeaderCartAccessibility(number, true);
    if (lineNumber && tempElement.querySelector("#" + lineNumber)) {
      var cartNodeParent = this.element.querySelector("#" + lineNumber);
      const itemToReplaceWith = tempElement.querySelector(
        "#" + lineNumber + " .cartItem--Informations"
      );
      if (cartNodeParent && cartNodeParent.querySelector(".itemLoader")) {
        cartNodeParent
          .querySelector(".itemLoader")
          .classList.remove("is-visible");
      }
      if (itemToReplaceWith) {
        cartNodeParent.replaceChild(
          itemToReplaceWith,
          cartNodeParent.querySelector(".cartItem--Informations")
        );
      } else {
        cartNodeParent.classList.add("removing");
        cartNodeParent.animate(
          [
            // keyframes
            { transform: "translateY(0px)", opacity: "1" },
            { transform: "translateY(30px)", opacity: "0" },
          ],
          {
            // timing options
            duration: 500,
            fill: "forwards",
          }
        );
        setTimeout(() => {
          cartNodeParent.remove();
        }, 500);

        if (this.options["showRecommendations"]) {
          this.loadRecommendations();
        }
      }


      if (number > 0) {
        const checkoutButtonParent = this.element.querySelector(
          ".CartDrawer--Footer"
        );
        const checkoutButtonToReplace = tempElement.querySelector(
          ".CartFooter--Totals"
        );
        const checkoutMetaParent = checkoutButtonParent.querySelector('.MetaIcon--Wrappers');
        if (checkoutMetaParent) {
          checkoutMetaParent.replaceChild(
            checkoutButtonToReplace,
            checkoutButtonParent.querySelector(".CartFooter--Totals")
          );
        }
      } else {
        this.element
          .querySelector(".CartDrawer--Footer")
          .classList.add("removing");
          this.recommendationsLoaded = false;
        const mainPartParent = this.element.querySelector(".CartDrawer");

        mainPartParent.innerHTML =
          tempElement.querySelector(".CartDrawer").innerHTML;


        if (window.theme.enableAnimations) {
          const mainPartchildren =
            mainPartParent.querySelector("#main-cartItems");
          mainPartchildren.animate(
            [
              // keyframes
              { opacity: "0" },
              { opacity: "1" },
            ],
            {
              // timing options
              duration: 500,
              fill: "forwards",
            }
          );
        }
      }
      if (this.element.querySelector(".itemLoader")) {
        setTimeout(() => {
          this.element
            .querySelector(".itemLoader")
            .classList.remove("is-visible");
        }, 250);
      }
    } else {
      const cartNodeParent =
        this.element.querySelector(".CartDrawer").parentNode;
      const currentScrollPosition =
        this.element.querySelector("#main-cartItems").scrollTop;

      cartNodeParent.replaceChild(
        tempElement.querySelector(".CartDrawer"),
        this.element.querySelector(".CartDrawer")
      );
      this.element.querySelector("#main-cartItems").scrollTop =
        currentScrollPosition;
    
    }
    if (window.theme.enableAnimations) {
      new RevolutionAnimation(this.element);
    }
    setTimeout(() => {
      if (this.options["showRecommendations"] && !quantityChange) {
        this.loadRecommendations();
      }
      if (!skipEvent) {
        var focus = _this.element.querySelector("[data-scrollable]");
        bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
      }

      _this.sidebarDrawer.maxHeight();
    }, 200);
  }

  loadRecommendations() {
    const _this = this;
    // Determine the URL to fetch recommendations based on the product ID option.
    const productId = this.options.productId;
    const url = productId
      ? `${window.routes.localeRootUrl}/recommendations/products?section_id=helper-recommendations&product_id=${productId}&limit=10`
      : "?section_id=helper-recommendations";

    // Fetch the recommendations and parse the HTML content.
    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (content) {
        const container = document.createElement("div");
        container.innerHTML = content;


        // Insert the recommendations HTML into the recommendations container.
        const upsellContainer = container.querySelector(".cartUpsell");
        const recommendationsContainer = _this.element.querySelector(".CartMobileRecommendations");
        if(_this.recommendationsLoaded == true && recommendationsContainer.querySelector('.cartSlideItem').id == upsellContainer.querySelector('.cartSlideItem').id){
          return;
         }
        recommendationsContainer.innerHTML = upsellContainer.innerHTML;

 
     
        
        // Initialize the Swiper instance with the recommendations container and options.
        const swiper = new Swiper(recommendationsContainer.querySelector(".swiperUpsell"), {
          slidesPerView: 2,
          spaceBetween: 0,
          slidesOffsetAfter: 0,
          slidesOffsetBefore: 0,
          resistanceRatio: 0,
          loop: false,
          pagination: {
            el: ".sidecart_pagination",
            type: "bullets",
            clickable: true,
          },
          breakpoints: {
            1025: {
              slidesPerView: 2,
              spaceBetween: 0,
              slidesOffsetAfter: 0,
              slidesOffsetBefore: 0,
              navigation: {
                nextEl: ".swiperNextCart",
                prevEl: ".swiperPrevCart",
              },
            },
          },
        });
   
        _this.recommendationsLoaded = true;
        // Dispatch a custom event to toggle favorites state.
        _this.element.dispatchEvent(new CustomEvent("favorites:toggle", { bubbles: true }));

        // Show the recommendations section and run the Revolution animation if enabled.

        const recommendationsSection = _this.element.querySelector(".cartRecommendations");
        recommendationsSection.style.display = "block";
       
        const cartDrawerRecommendation = _this.element.querySelector(".cartRecommendations");

        let cartDrawerSlidesRecommendation = _this.element.querySelectorAll('.cartRecommendations .cartSlideItem');
        if (cartDrawerSlidesRecommendation.length === 0) {

          cartDrawerRecommendation.style.display = 'none';
        }

        if (window.theme.enableAnimations) {
          new RevolutionAnimation(_this.element);
        }
      })
      .catch(function (error) {
        // Handle the error gracefully by logging it or displaying an error message to the user.
        // For this implementation, we will not output errors to the console.
        // Instead, we can display an error message in the UI or send the error to a monitoring service.
      });
  }
}
customElements.define("cart-drawer", CartDrawer);

class FeaturedCollectionSection extends HTMLElement {
  constructor() {
    super();
    var _this = this;
    this.element = this;
    this.domDelegate = new Delegate(this.element);
    this.carouselElement = this.element.querySelector(".swiper");
    //this.carousel = new RevolutionSwiper(this.carouselElement);
    //this.swiper = this.carousel.swiperElement;

    this.bindEvents();

    new AddToCart(this.element);
  }

  bindEvents() {
    this.isPageLoaded =
      document.readyState === "complete" ||
      document.readyState === "loaded" ||
      document.readyState === "interactive";
    if (!this.isPageLoaded) {
      window.addEventListener("load", this.onPageLoaded.bind(this));
    } else {
      this.onPageLoaded();
    }

    this.domDelegate.on("product-slider:disable", () => { this.swiper.allowTouchMove = false; });
    this.domDelegate.on("product-slider:enable", () => { this.swiper.allowTouchMove = true; });
  }



  onPageLoaded() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.carousel = new RevolutionSwiper(this.carouselElement);
      this.swiper = this.carousel.swiperElement;
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "-100px 0px 200px 0px",
    }).observe(this);
  }
}
customElements.define("featured-collection", FeaturedCollectionSection);

class SliderTextSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);

  }


}
customElements.define("slider-text", SliderTextSection);

class Banner extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.delegateElem = new Delegate(this.element);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.carouselElement = this.element.querySelector("[data-swiper-settings]");
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.delegateElement = new Delegate(this.element);
    if (this.options["numberOfSlides"] > 1) {
      this.carousel = new RevolutionSwiper(this.carouselElement);
      this.swiper = this.carouselElement.swiper;
      this.onImagesReady = this.createObserver.bind(this);
      this.element.addEventListener("swiper:slide-changed", this.onImagesReady);
      this.createObserver();
    } else {
      this.createObserver();
    }

    this.bindEvents();
  }

  bindEvents(){
    this.delegateElem.on("banner:disable", () => this.swiper.allowTouchMove = false);
    this.delegateElem.on("banner:enable", () => this.swiper.allowTouchMove = true);
  }

  createObserver() {
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.5,
    });

    const target = this.element;
    this.observer.observe(target);
  }

  handleIntersect(entries) {
    var _this = this;
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (_this.options["numberOfSlides"] > 1) {
          _this.changeImageQuality();
        } else {
          _this.changeImageQuality(true);
        }
        _this.observer.unobserve(_this);
      }
    });
  }
  changeImageQuality(singleItem) {
    // Get the current breakpoint.
    const breakpoint = new Responsive().getCurrentBreakpoint();


    let imageContainers;
    // Determine which element(s) to search for based on the singleItem parameter.
    if (singleItem) {
      imageContainers = Array.from(
        this.element.querySelectorAll(".Banner__ImageContainer--Swap")
      );
    } else {
      const currentIndex = this.carousel.swiperElement.activeIndex;
      const cellElement = this.carousel.swiperElement.slides[currentIndex];
      imageContainers = Array.from(
        cellElement.querySelectorAll(".Banner__ImageContainer--Swap")
      );
    }

    // If no image containers are found, return.
    if (imageContainers.length === 0) {
      return;
    }

    // Determine which image to reveal based on the current breakpoint.
    let imageToReveal;
    if (
      breakpoint === "pocket" ||
      breakpoint === "phone" ||
      breakpoint === "tablet"
    ) {
      imageToReveal = imageContainers[0].querySelector(".Banner__Image");
    } else {
      if (imageContainers.length == 2) {
        imageToReveal = imageContainers[1].querySelector(".Banner__Image");
      } else {
        imageToReveal = imageContainers[0].querySelector(".Banner__Image");
      }
    }

    // If the image to reveal is not found or has already been loaded, return.
    if (!imageToReveal || imageToReveal.dataset.loadedImage === "true") {
      return;
    }
    // Replace the image URL with a higher quality version.
    const replaceUrl = imageToReveal.dataset.src.replace(
      "{width}x",
      "width=2600"
    );
    imageToReveal.src = replaceUrl;
    imageToReveal.dataset.loadedImage = "true";
  }
}
customElements.define("banner-hero", Banner);

class Header extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.getAttribute("data-settings"));
    this.heroBanner = document.querySelector('.HeroBannerFirst');
    if(document.querySelector('#header').offsetHeight > 0){
      document.documentElement.style.setProperty('--header-height', document.querySelector('#header').offsetHeight + 'px');
    }

    this.updateVisibleHeight();
    this.toggleColor();
    var selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");
    if (selectBoxes.length > 0) {
      selectBoxes.forEach((item, i) => {
        new RevolutionSelectbox(item);
      });
    }

    if (this.heroBanner) this.element.style.borderColor = "transparent";

    if (this.options.sticky) {
      this.toggleSticky();
    } else {
      window.addEventListener('scroll', this.updateVisibleHeight.bind(this));
      window.addEventListener('resize', this.updateVisibleHeight.bind(this));
    }
    this.bindEvents();

  }

  updateVisibleHeight() {
    const rect = this.element.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // Calculate the visible height
    let visibleHeight = Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);
    // Ensure the visibleHeight is never negative
    this.visibleHeight = Math.max(visibleHeight, 0);
    window.visibleHeader = this.visibleHeight;
    // Update the height of .announcementBar with the visible height

  }

  toggleSticky() {
    this.element.parentElement.classList.add("header--Sticky");
    document.body.classList.add("headerSticky");
    this.element.parentElement.classList.remove("Header--Transparent");

  }

  bindEvents() {
    const _this = this;

    this.toggleColorListener = this.toggleColor.bind(this);

    window.addEventListener("scroll", this.toggleColorListener);
    this.delegateBody.on("menu:close", this.closeMenu.bind(this), true);

    this.delegateElement.on(
      "mouseenter",
      '[aria-haspopup="menu"]',
      this.openMenu.bind(this),
      true
    );

    this.delegateElement.on(
      "focusin",
      '[aria-haspopup="menu"]',
      this.openMenu.bind(this),
      true
    );

    this.delegateElement.on(
      "mouseleave",
      "[data-submenu]",
      this.closeMenu.bind(this),
      true
    );

    this.delegateElement.on(
      "mouseenter",
      "[data-single-menu]",
      this.closeMenu.bind(this),
      true
    );

    this.delegateElement.on(
      "focusin",
      "[data-single-menu], .mainLinks",
      this.closeMenu.bind(this),
      true
    );

    this._escapeMenuListener = this.onEscapeMenu.bind(this);
    document.addEventListener("keydown", this._escapeMenuListener); // delegate-exempt: Escape closes desktop menu

    if (this.options.transparent) {
      this.delegateBody.on(
        "header:transparent",
        (e) => {
          !e.detail ? this.element.classList.remove('Header--Transparent') : setTimeout(() => this.element.classList.add('Header--Transparent'), 330);
          !e.detail ? this.element.style.borderColor = "var(--secondary_grey_light)" : setTimeout(() => this.element.style.borderColor = "transparent", 330);
        },
        true
      );
    }
  }

  onEscapeMenu(event) {
    if (event.key !== "Escape") {
      return;
    }

    const openTrigger = this.element.querySelector(
      '[aria-haspopup="menu"][aria-expanded="true"]'
    );
    if (!openTrigger) {
      return;
    }

    event.preventDefault();
    this.closeMenu(event, openTrigger);
    openTrigger.focus();
  }

  updateMenuPosition() {
    document.documentElement.style.setProperty(
      "--submenu-position",
      `${document.querySelector("#header").offsetHeight}px`
    );
  }

  openMenu(event, target) {
    // Dispatch a custom event to indicate that the menu is being opened.
    this.element.dispatchEvent(new CustomEvent("menu:open", { bubbles: true }));

    // If the event is a mouseenter event and the target is not the same as the event target, return.
    if (event.type === "mouseenter" && target !== event.target) {
      return;
    }


    // Update the position of the menu and change the ARIA expanded attribute.
    this.updateMenuPosition(target);
    this.element.classList.remove("Header--Transparent");
    target.setAttribute("aria-expanded", "true");

    // Close any siblings of the target element.
    const siblings = Array.from(target.parentElement.children).filter(
      (child) =>
        child !== target && child.getAttribute("aria-expanded") === "true"
    );
    siblings.forEach((item) => item.setAttribute("aria-expanded", "false"));

    // Disable body scroll on the scrollable element inside the menu.
    const scrollableElement = this.element.querySelector("[data-scrollable]");
    if (!scrollableElement) {
      return;
    }
    bodyScrollLock.disableBodyScroll(scrollableElement, bodyScrollLockOptions);
  }

  closeMenu(event, target) {
    if (event.type === "mouseleave" && target !== event.target) {
      return;
    }


    const allOpen = this.element.querySelectorAll('[aria-haspopup="menu"][aria-expanded="true"]');
    allOpen.forEach(function (item) {
      item.setAttribute("aria-expanded", "false");
    });
    this.toggleColor();
    bodyScrollLock.clearAllBodyScrollLocks();
  }

  toggleColor() {
    if (window.pageYOffset > 25) {
      this.element.classList.add("Header--Scrolled");
      if (this.heroBanner && this.options.sticky) this.element.style.borderColor = "var(--secondary_grey_light)";
    } else {
      this.element.classList.remove("Header--Scrolled");
      if (this.heroBanner && this.options.sticky) this.element.style.borderColor = "transparent";
    }



    if(document.querySelector('#mobileMenu').getAttribute('aria-expanded') == 'true'){ return}
    if (this.options.transparent) {
      if (window.pageYOffset > 25 && this.options.sticky) {
        this.element.classList.remove("Header--Transparent");
      } else {
        this.element.classList.add("Header--Transparent");
      }
    }
  }
}
customElements.define("header-component", Header);

class MainMenuDropdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.SidebarMenu = new Drawer(this.element);


    this.carouselElement = this.element.querySelector(".MenuSlideshowMobile");
    if (this.element.querySelector('[data-toggle-id="helpDrawer"]')) new Drawer(document.querySelector('#helpDrawer'));

  }

}
customElements.define("main-menu-dropdown", MainMenuDropdown);

class Transition {
  constructor() {
    this.pageOverlay = document.querySelector(".pageTransition");

    if (!this.isPageLoaded) {
      document.addEventListener(
        "DOMContentLoaded",
        this.onPageLoaded.bind(this)
      );
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    this.isPageLoaded = true;
    if (this.pageOverlay && window.theme.showPageTransition) {
      this.pageOverlay.animate([{ opacity: 1 }, { opacity: 0 }], {
        duration: 100,
        fill: "forwards",
        easing: "ease-in-out",
        iterations: 1,
      });
    }
  }

  onPageUnload(event, target) {
    if (
      event.defaultPrevented ||
      event.ctrlKey ||
      event.metaKey ||
      !window.theme.showPageTransition ||
      !this.pageOverlay
    ) {
      return;
    }

    event.preventDefault(); // Prevent the click to happen

    if (this.pageOverlay) {
      var timeline = new TimelineLite({
        onComplete: function onComplete() {
          window.location.href = target.href;
        },
      });

      timeline.fromTo(
        this.pageOverlay,
        0.25,
        { autoAlpha: 0, ease: Linear.easeNone },
        { autoAlpha: 1, ease: Linear.easeNone }
      );
    }
  }
}
var trans = new Transition();

class VideoComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.trueObserver = false;

    if (this.options["using_fade"] == "fade") {
      var childOfSlide = this.element.closest(".swiper-slide");
      if (childOfSlide) {
        if (
          this.element.dataset.position == 0 ||
          childOfSlide.classList.contains("swiper-slide-active") ||
          childOfSlide.classList.contains("swiper-slide-duplicate-active")
        ) {
          this.checkLoaded();
          this.bindEvents();
        } else {
          this.bindEvents();
        }
      }
    } else {
      this.checkLoaded();
    }
  }

  bindEvents() {
    window.removeEventListener(
      "swiper:slide-changed",
      this.onSlideChangeListener
    );
    this.onSlideChangeListener = this.onSlideChange.bind(this);
    window.addEventListener("swiper:slide-changed", this.onSlideChangeListener);
  }

  checkLoaded() {
    var _this = this;
    if (typeof videojs !== "undefined") {
      this.videoPlayerInitialization();
    } else {
      loadScript(window.theme.videoScript);
      setTimeout(function () {
        _this.checkLoaded();
      }, 100);
    }
  }

  onSlideChange(event) {
    this.elementPosition = parseInt(this.element.getAttribute("data-position"));
    if (event.detail.currentIndex == this.elementPosition) {
      if (!this.element.getAttribute("loaded")) {
        var node = document.createElement("div");
        node.appendChild(
          this.element
            .querySelector("template")
            .content.firstElementChild.cloneNode(true)
        );
        this.element.appendChild(node.firstElementChild).focus();
        this.element.setAttribute("loaded", true);
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else {
          if (this.options["viewport"]) {
            this.videoPlayer.play();
            this.createObserver();
          }
        }
      } else {
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else {
          if (this.options["viewport"]) {
            this.videoPlayer.play();
            this.createObserver();
          }
        }
      }
    } else if (
      this.videoPlayer &&
      this.videoPlayer.el_.classList.contains("vjs-playing")
    ) {
      this.videoPlayer.pause();
    }
  }

  videoPlayerInitialization() {
    if (!this.element.getAttribute("loaded")) {
      const node = document.createElement("div");
      node.appendChild(
        this.element
          .querySelector("template")
          .content.firstElementChild.cloneNode(true)
      );
      this.element.appendChild(node.firstElementChild).focus();
      this.element.setAttribute("loaded", true);
    }


    const responsive = new Responsive();
    const breakpoint = responsive.getCurrentBreakpoint();
    const isMobile = breakpoint === "phone" || breakpoint === "tablet";


    let aspect_ratio = "";
    let src = "";
    let host = "html5";

    if (isMobile) {
      aspect_ratio = this.options["aspect_mob"] || "9:16";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["videoRatio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        } else {
          aspect_ratio = this.options['videoRatio'];
        }
        src = topQuality['url'] + "#t=0.001";
      } else if (this.options["videoType"] == 'video_inside_media_external') {
        const aspectRatioHeight = Math.floor(100 / this.options["videom"]["aspect_ratio"]);
        if (!this.options['videoRatio']) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        } else {
          aspect_ratio = this.options['videoRatio'];
        }
        host = this.options["videom"]["host"];
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videom"]["external_id"];
        } else {
          src = this.options["videom"]["external_id"];
        }
      } else {
        if (this.options["videom"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videom"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videom"];
      }
    } else {
      aspect_ratio = this.options["aspect_desk"] || "16:9";
      if (this.options["videoType"] == 'video_inside_media') {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        src = topQuality["url"] + "#t=0.001";
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["videoRatio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        } else {
          aspect_ratio = this.options['videoRatio'];
        }
      } else if (this.options["videoType"] == "video_inside_media_external") {
        host = this.options["videod"]["host"];
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["videoRatio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        } else {
          aspect_ratio = this.options['videoRatio'];
        }
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videod"]["external_id"];
        } else {
          src = this.options["videod"]["external_id"];
        }
      } else {
        if (this.options["videod"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videod"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videod"];
      }
    }
    if (!src) {
      src = "https://www.youtube.com/watch?v=_9VUPq3SxOc";
      host = "youtube";
    }

    if (host === "youtube" && !this.options.controls) {
      this.initYouTubeBackgroundEmbed(src);
      return;
    }

    const type =
      host === "youtube"
        ? "video/youtube"
        : host === "vimeo"
          ? "video/vimeo"
          : "video/mp4";

    aspect_ratio = aspect_ratio.replace("/", ":");
    const payload = {
      aspectRatio: aspect_ratio,
      autoplay: false,
      muted: this.options["muted"],
      loop: this.options["loop"],
      controls: this.options["controls"],
      poster: false,
      preload: "metadata",
      playsinline: true,
      responsive: true,
      techOrder: [host],
      disablePictureInPicture: true,
      controlBar: {
        children: [
          "playToggle",
          "progressControl",
          "currentTimeDisplay",
          "timeDivider",
          "durationDisplay",
          "CustomControlSpacer",
          "VolumePanel"
        ],
      },

      sources: [
        {
          type: type,
          src: src,
        },
      ],
    };

    const videoplayerID = this.element.querySelector("video");
    if (videoplayerID) this.videoPlayer = videojs(videoplayerID, payload);

    const _this = this;
    this.videoPlayer.on("ready", function () {
      _this.element.querySelector(".videoHolder").style.display = "block";

      if (_this.trueObserver == false && _this.options["viewport"]) {
        _this.createObserver();
      }
    });

    if (this.options['muted'] && host == 'vimeo') {
      this.videoPlayer.on('play', function () {

        _this.videoPlayer.muted("true");
      })
    }

    if (this.options["controls"]) {
      this.videoPlayer.on("touchstart", function () {
        if (event.target.closest('.vjs-control-bar')) {
          return;
        }
        if (_this.videoPlayer.paused()) {
          _this.videoPlayer.play();
        } else {
          _this.videoPlayer.pause();
        }
      });
    }

    const volumeControl = this.element.querySelector('.vjs-volume-panel');
    const progressControl = this.element.querySelector('.vjs-progress-control');
    if (volumeControl) {
      volumeControl.addEventListener('mouseenter', () => this.element.dispatchEvent(new CustomEvent('banner:disable', { bubbles: true })));
      volumeControl.addEventListener('mouseleave', () => this.element.dispatchEvent(new CustomEvent('banner:enable', { bubbles: true })));
    }
    if (progressControl) {
      progressControl.addEventListener('mouseenter', () => this.element.dispatchEvent(new CustomEvent('banner:disable', { bubbles: true })));
      progressControl.addEventListener('mouseleave', () => this.element.dispatchEvent(new CustomEvent('banner:enable', { bubbles: true })));
    }
  }

  extractYouTubeId(src) {
    if (!src) return null;
    const match = String(src).match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&?/]+)/);
    return match ? match[1] : null;
  }

  initYouTubeBackgroundEmbed(src) {
    const videoId = this.extractYouTubeId(src);
    if (!videoId) return;

    const videoHolder = this.element.querySelector('.videoHolder');
    const videoEl = this.element.querySelector('video');
    if (!videoHolder) return;

    if (videoEl) videoEl.remove();

    const iframe = document.createElement('iframe');
    const params = new URLSearchParams({
      enablejsapi: '1',
      autoplay: this.options.viewport ? '1' : '0',
      mute: this.options.muted ? '1' : '0',
      controls: '0',
      loop: this.options.loop ? '1' : '0',
      playlist: videoId,
      playsinline: '1',
      modestbranding: '1',
      rel: '0',
      iv_load_policy: '3',
      disablekb: '1',
      origin: window.location.origin,
    });

    iframe.src = `https://www.youtube-nocookie.com/embed/${videoId}?${params}`;
    iframe.title = this.options.videoTitle || 'Video';
    iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
    iframe.className = 'youtube-background-embed';
    iframe.setAttribute('aria-hidden', 'true');

    videoHolder.appendChild(iframe);
    videoHolder.style.display = 'block';
    videoHolder.setAttribute('aria-hidden', 'true');
    this.element.setAttribute('aria-hidden', 'true');
    this.youtubeIframe = iframe;
    this.isYouTubeBackground = true;
    this.element.setAttribute('loaded', true);

    if (this.options.viewport) {
      this.createObserver();
    }
  }

  postYouTubeCommand(command) {
    if (!this.youtubeIframe || !this.youtubeIframe.contentWindow) return;
    this.youtubeIframe.contentWindow.postMessage(
      JSON.stringify({ event: 'command', func: command, args: '' }),
      '*'
    );
  }

  createObserver() {
    const observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.2,
      rootMargin: "200px 0px 200px 0px",
    });

    observer.observe(this.element);
    this.trueObserver = true;
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {

      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {

        if (this.isYouTubeBackground) {
          this.postYouTubeCommand('playVideo');
          return;
        }

        if (!this.videoPlayer) {
          this.checkLoaded();
          return;
        }

        if (this.options["viewport"] && this.videoPlayer) {

          if (this.options["muted"]) {
            this.videoPlayer.muted("true");
          }
          const checkIfPlaying = () => {
            if (!this.videoPlayer.el_.classList.contains("vjs-playing")) {
              this.videoPlayer.play();
              setTimeout(checkIfPlaying, 100);
            }
          };

          checkIfPlaying();
        }
      } else if (
        entry.intersectionRatio === 0 ||
        entry.isIntersecting == false
      ) {
        if (this.isYouTubeBackground) {
          this.postYouTubeCommand('pauseVideo');
          return;
        }

        if (
          this.videoPlayer &&
          this.videoPlayer.el_.classList.contains("vjs-playing")
        ) {
          this.videoPlayer.pause();
        }
      }
    });
  }
}
customElements.define("video-component", VideoComponent);


class ProductElement extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.domDelegate = new Delegate(this.element);
    this.carouselElement = this.element.querySelector(".mainSwiper");
    this.carouselElementThumbs = this.element.querySelector(
      ".ProductSlider--Thumbnails"
    );

    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );

    if (this.options['masonary']) this.handleMediaWrapper();

    const dropdowns = document.querySelectorAll('.ProductInfo--Wrapper .Dropdown');
    dropdowns[0].style.paddingTop = "32px";
    dropdowns[dropdowns.length - 1].style.marginBottom = "16px";

    if (this.options['slides_number'] > 1) {
      if (this.options['show_thumbnails']) {
        this.carousel = new RevolutionSwiper(
          this.carouselElement,
          this.carouselElementThumbs
        );
      } else {
        this.carousel = new RevolutionSwiper(this.carouselElement);
      }
    }
    this.swiper = this.carouselElement.swiper;


    this.changeImageQuality();
    this.valuesWrap = this.element.querySelectorAll(
      ".ProductOption--ValusWrapper"
    );
    var localPickup = this.element.querySelector("#LocalPickup");
    if (localPickup) {
      new Drawer(this.querySelector("#LocalPickup"));
    }
    new AddToCart(this.element);
    //new Dropdown(this.element.querySelector(".ProductInfo--Wrapper"));

    if (this.options["enable_zoom"]) {
      new RevolutionImageZoom(this.element, this.carousel);
    }

    var selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");
    var selectBoxesV2 = this.element.querySelectorAll(".RevolutionSelectboxV2")
    if (selectBoxes.length > 0) {
      selectBoxes.forEach((item, i) => {
        new RevolutionSelectbox(item);
      });
    }
    if (selectBoxesV2.length > 0) {
      selectBoxesV2.forEach((item, i) => {
        new RevolutionSelectbox(item);
      });
    }

    if (this.options['variant_image_id'] && this.options['show_variant_image_on_load']) {
      this.updateImage();
    }

    if (this.options['sticky_atc']) {
      this.footer = document.getElementById("shopify-section-main-footer");
      this.elementToHide = this.element.querySelector('.ProductAction--Sticky');
      this.btnVis = true;
      this.footerVis = false;
      this.elementToHide.classList.remove('stickyPopUp');
      this.bindObserver();
    }

    this.bindEvents();
    this.handleColumnScheme();
  }

  bindEvents() {
    this.domDelegate.on("variant:changed", this.updateImage.bind(this));
    this.domDelegate.on("click", ".ProductAction--ChangeButton", this.scrollToTop.bind(this));
    if (this.footer) {
      this.debouncedFunc = debounce(this.checkFooterVis.bind(this), 50);
      window.addEventListener('scroll', this.debouncedFunc);
    }
    if(!this.swiper) return;
    this.swiper.on("slideChange", this.toggleFavoritesIcon.bind(this));
  }

  toggleFavoritesIcon() {
    const activeSlide = this.swiper.slides[this.swiper.activeIndex];
    if (activeSlide) {
      const favoritesIcon = this.element.querySelector('.product-favorite__button--pdp-gallery');

      if (activeSlide.querySelector('video-component')) favoritesIcon.style.opacity = 0;
      else favoritesIcon.style.opacity = 1;
    }
  }

  bindObserver() {
    const elementToObserve = this.element.querySelector('.ScrollToATC');

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting || entry.intersectionRatio == 1 || elementToObserve.getBoundingClientRect().top >= window.innerHeight) {
          this.btnVis = true;
          this.elementToHide.classList.remove('stickyPopUp');
        } else {
          if (!this.footerVis) {
            this.btnVis = false;
            this.elementToHide.classList.add('stickyPopUp');
          }
        }
      });
    });

    observer.observe(elementToObserve);
  }

  checkFooterVis() {
    if (this.footer.getBoundingClientRect().top <= window.innerHeight) {
      this.elementToHide.classList.remove('stickyPopUp');
      this.footerVis = true;
    } else {
      if (!this.btnVis) {
        this.footerVis = false;
        this.elementToHide.classList.add('stickyPopUp');
      }
    }
  }

  scrollToTop() {
    const elementToScroll = this.element.querySelector(".ScrollToATC");

    if (elementToScroll) {
      const elementTop = elementToScroll.getBoundingClientRect().top;
      const positionToScroll = elementTop + window.scrollY + elementToScroll.clientHeight - window.innerHeight + 32;

      window.scrollTo({
        top: positionToScroll,
        behavior: "smooth"
      });
    }
  }

  handleMediaWrapper() {
    const mediaWrapper = this.element.querySelector('.Product--ViewDesktop');
    if (mediaWrapper) {
      const mediaWrapperChildren = Array.from(mediaWrapper.children);
      const div1 = document.createElement('div');
      const div2 = document.createElement('div');

      mediaWrapperChildren.forEach((childNode, index) => {
        const clone = mediaWrapperChildren[index].cloneNode(true);

        if (index % 2 === 0) div1.appendChild(clone);
        else div2.appendChild(clone);

        mediaWrapper.removeChild(childNode);
      });

      mediaWrapper.appendChild(div1);
      mediaWrapper.appendChild(div2);
    }
  }

  handleColumnScheme() {
    const customDropdowns = this.element.querySelectorAll('.CD--DropdownContent__Inner');
    const filteredDropdowns = Array.from(customDropdowns).filter(dropdown => dropdown.childElementCount > 5);
    filteredDropdowns.forEach(dropdown => dropdown.classList.add('twoRows'));
  }

  updateImage(event) {
    if (event) {
      var imageID = event.detail.new_image;
    } else {
      var imageID = this.options["variant_image_id"];
    }


    var selector = "#Image--" + imageID;
    var imageEl = this.element.querySelector(selector);

    if (imageEl) {
      this.carousel.selectCell(parseInt(imageEl.getAttribute("data-position")));
    }
  }

  changeImageQuality() {
    var imageToReveal = null;
    imageToReveal = this.element.querySelectorAll(".ProductSlider--ImageFirst");

    if (imageToReveal !== null) {
      imageToReveal.forEach((item) => {
        const replaceUrl = item.getAttribute("data-src")
        .replace("{width}x", "2600x");
      item.src = replaceUrl;

      })

    }
  }
}
customElements.define("product-component", ProductElement);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.type = this.element.getAttribute("data-type");
    this.productID = this.element.getAttribute("data-product-id");
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.firstCall = true;

    this.updateOptions();
    this.updateMasterId();
    this.bindEvents();
    }

  bindEvents() {
    this.delegateBody.on("quantity:changed", this.onQuantityChange.bind(this));

    var selectboxes = this.element.querySelectorAll("select, input");
    selectboxes.forEach((item) => {
      item.addEventListener("change", this.onVariantChange.bind(this));
    });
  }

  onQuantityChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton();
    this.updatePickupAvailability();

    this.updateMedia();
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInfo();
  }


  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select, input:checked"),
      (select) => select.value
    );
  }

  updateMasterId() {
    if (this.firstCall) {
      var options = localStorage.getItem('itemOptions');
      if (options) {
        options = options.split(',');

        this.currentVariant = this.getVariantData().find((variant) => {
          options;
          return !variant.options
            .map((option, index) => {
              return options[index] === option;
            })
            .includes(false);
        });
        
        localStorage.setItem('itemOptions', options);
        this.firstCall = false;
        if (this.currentVariant && this.currentVariant.available){
          options.forEach(option => this.element.dispatchEvent(new CustomEvent("selectbox:checked", { bubbles: true, detail: document.querySelector(`input[data-value="${option}"]`) })))
          this.onVariantChange();
          return;
        }
      }
    }

    this.currentVariant = this.getVariantData().find((variant) => {
      this.options;
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });

    localStorage.setItem('itemOptions', this.options);
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const newMedia = this.currentVariant.featured_media.id;
    if (!newMedia) return;
    this.element.dispatchEvent(
      new CustomEvent("variant:changed", {
        bubbles: true,
        detail: { new_image: newMedia },
      })
    );
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}`
    );
  }

  updateVariantInput() {
    if (!this.currentVariant) return;
    const productForms = document.querySelectorAll(
      `#product-form-${this.productID}, #product-form-installment`
    );

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  renderProductInfo() {
    if (!this.currentVariant) return;
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = ".ProductInfo--Prices";
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destinations = document.querySelectorAll(id);
        const source = html.querySelector(id);

        if (source && destinations) {
          destinations.forEach((destination) => {
            destination.innerHTML = source.innerHTML;
          });
        }

        const quantityButton = document.querySelector(".QuantityHandler");
        if (quantityButton) {
          const source = html.querySelector(".QuantityHandler");
          if (source && quantityButton)
            quantityButton.innerHTML = source.innerHTML;
        }
        this.toggleAddButton();
      });
  }

  toggleAddButton() {
    if (!this.currentVariant) return;
    let quantity = "";
    const addButton = document.querySelector(".ProductPage--ATC"),
      addButtonInner = addButton.querySelector(".SelfAlign"),
      quantityEl = document.querySelector(".QuantitySelector__ProductQuantity");
    const stickyAddButton = document.querySelector(".ProductAction--StickyButton"),
      stickyAddButtonInner = stickyAddButton.querySelector(".SelfAlign");

    if (quantityEl) {
      quantity = quantityEl.value;
    }
    if (window.variantInfo.show_icon) {
      var buySvg =
        '<svg class="Svg Svg--shopping_cart mr-m" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M25.31 5.19547C25.1687 5.02127 24.9568 4.91946 24.7325 4.91797H9.11751L9.60501 6.41797H23.75L21.7475 15.418H10.4975L7.07001 4.56547C6.99476 4.33174 6.80986 4.14965 6.57501 4.07797L3.50001 3.13297C3.24278 3.05393 2.96292 3.11812 2.76584 3.30137C2.56877 3.48461 2.48443 3.75907 2.54459 4.02137C2.60476 4.28366 2.80028 4.49393 3.05751 4.57297L5.75001 5.39797L9.19251 16.273L7.96251 17.278L7.86501 17.3755C7.2374 18.0987 7.21221 19.1659 7.80501 19.918C8.21952 20.4221 8.84817 20.7002 9.50001 20.668H22.0175C22.4317 20.668 22.7675 20.3322 22.7675 19.918C22.7675 19.5038 22.4317 19.168 22.0175 19.168H9.38001C9.20436 19.162 9.0446 19.0646 8.95873 18.9113C8.87286 18.7579 8.87334 18.5709 8.96001 18.418L10.7675 16.918H22.3475C22.705 16.9267 23.0189 16.6818 23.0975 16.333L25.475 5.83297C25.5212 5.6064 25.4603 5.37117 25.31 5.19547ZM20.75 25.168C21.682 25.168 22.4375 24.4125 22.4375 23.4805C22.4375 22.5485 21.682 21.793 20.75 21.793C19.818 21.793 19.0625 22.5485 19.0625 23.4805C19.0625 24.4125 19.818 25.168 20.75 25.168ZM12.185 23.4805C12.185 24.4125 11.4295 25.168 10.4975 25.168C9.56553 25.168 8.81001 24.4125 8.81001 23.4805C8.81001 22.5485 9.56553 21.793 10.4975 21.793C11.4295 21.793 12.185 22.5485 12.185 23.4805Z" fill="#121212"></path></svg>';
    } else {
      var buySvg = "";
    }

    if (!addButton) return;
    if (!quantity) {
      quantity = 1;
    }

    if (this.currentVariant.available == false) {
      addButton.setAttribute("disabled", "disabled");
      addButton.classList.add("ProductCard--Sold__Out");
      addButtonInner.classList.add("u-p3");
      addButtonInner.innerHTML = buySvg + window.variantStrings.soldOut;
      if (stickyAddButton && stickyAddButtonInner) {
        stickyAddButton.setAttribute("disabled", "disabled");
        stickyAddButton.classList.add("ProductCard--Sold__Out");
        stickyAddButtonInner.classList.add("u-p3");
        stickyAddButtonInner.innerHTML = buySvg + window.variantStrings.soldOut;
      }
    } else {
      addButton.removeAttribute("disabled");
      addButton.classList.remove("ProductCard--Sold__Out");
      if (stickyAddButton && stickyAddButtonInner) {
        stickyAddButton.removeAttribute("disabled");
        stickyAddButton.classList.remove("ProductCard--Sold__Out");
      }
      if (window.variantInfo.show_price) {
        var priceElement =
          "<span class='u-pb1 ml-s'>" +
          Shopify.formatMoney(
            this.currentVariant.price * quantity,
            window.theme.moneyFormat
          );
        +"</span>";
      } else {
        var priceElement = "";
      }

      addButtonInner.innerHTML =
        buySvg + window.variantStrings.addToCart + priceElement;

      if (stickyAddButton && stickyAddButtonInner) stickyAddButtonInner.innerHTML = buySvg + window.variantStrings.addToCart + priceElement;
    }
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define("variant-selects", VariantSelects);

class SearchBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.searchInputElement = this.element.querySelector('[name="q"]');
    this.searchElement = this;
    this.searchResultsElement = this.element.querySelector(".searchWrapper");
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.initialSearchLayout = this.searchResultsElement.cloneNode(true);
    this.clearSearchButton = this.element.querySelector(".searchInput--clear");
    if (window.theme.showRecentSearches) {
      this.getRecentSearches();
    }
    if (window.theme.showSuggestedSearches) {
      this.getSuggestedSearches();
    }

    this.carouselElement = this.element.querySelector(".searchInitialView");
    if (this.carouselElement) {
      if (new Responsive().matchesBreakpoint("lap-and-up")) {
        this.carousel = new RevolutionSwiper(this.carouselElement);
      }
    }

    document.documentElement.style.setProperty(
      "--search-header-height",
      `${this.searchInputElement.offsetHeight + 48}px`
    );


    this.bindEvents();
  }

  bindEvents() {
    this._onInputListener = this.debounce(this.onInput.bind(this), 450);

    this.delegateElement.on(
      "click",
      '[data-action="open-search"]',
      this.openSearch.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="clear-input"]',
      this.resetSearch.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="close-search"]',
      this.closeSearch.bind(this)
    );

    this.searchInputElement.addEventListener("input", this._onInputListener);

    this.delegateElement.on(
      "click",
      '[data-action="search-string"]',
      this.onRecentSearchClick.bind(this)
    );

    this.delegateElement.on(
      "keypress",
      '[data-action="search-string"]',
      this.onInput.bind(this)
    );
    this.delegateBody.on("menu:open", this.closeSearch.bind(this));
    this.delegateBody.on("close:search", this.closeSearch.bind(this));
  }

  initCarousel() {
    if (new Responsive().matchesBreakpoint("lap-and-up")) {
      var carousel = this.searchResultsElement.querySelector(
        "[data-swiper-settings]"
      );
      if (carousel) {
        this.newCarousel = new RevolutionSwiper(carousel);
      }
    }
  }

  debounce(fn, delay) {
    var _this0 = this;

    var timer = null;

    return function () {
      for (
        var _len = arguments.length, args = Array(_len), _key = 0;
        _key < _len;
        _key++
      ) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timer);

      timer = setTimeout(function () {
        fn.apply(_this0, args);
      }, delay);
    };
  }

  openSearch(event) {
    event.preventDefault();
    this.element.dispatchEvent(
      new CustomEvent("cart-drawer:close-other", { bubbles: true })
    );
  
    if (this.isOpen) {
      this.closeSearch();
      return;
    }
  
    const { element, options, searchInputElement, pageOverlayElement } = this;
    const target = event.target;

    const searchOverlay = document.querySelector('.pageOverlaySearch')
  
    if (!element) {
      console.error("Search element not found");
      return;
    }
  
    if (!element.querySelector(".searchSlide") && options["product"] && !options["collection"]) {
      this.loadRecommendations();
    }
  
    const search = target.parentElement.querySelector(".search");
    if (search) {
      search.setAttribute("aria-hidden", false);
    }
    if (new Responsive().matchesBreakpoint('lap-and-up')) {
      pageOverlayElement.classList.add("is-visible");
    }


    if (bodyScrollLock && element) {
      bodyScrollLock.disableBodyScroll(element.querySelector("[data-scrollable]"), bodyScrollLockOptions);
    }
  
    if (element) {
      element.dispatchEvent(new CustomEvent("menu:close", { bubbles: true }));
    }
    document.body.classList.add("scrollLock");
  
    setTimeout(() => {
      if (searchInputElement) {
        // Mouse open: keep focus for SR/typing without a visible ring.
        // Keyboard open (user-is-tabbing): allow :focus-visible ring.
        const fromKeyboard = document.body.classList.contains('user-is-tabbing');
        searchInputElement.focus(
          fromKeyboard ? undefined : { preventScroll: true, focusVisible: false }
        );
      }
    }, 200);
  
    if (!new Responsive().matchesBreakpoint('lap-and-up')) {
      searchOverlay.classList.add('is-visible');
    }

    document.body.classList.add("search-open");
  
    if (options["transparent"]) {
      setTimeout(() => {
        const header = document.body.querySelector("#header");
        if (header) {
          header.classList.remove("Header--Transparent");
        }
      }, 15);
    }
  
    this.isOpen = true;

    if (!new Responsive().matchesBreakpoint('lap-and-up')) {
      this.closeListener = this.closeSearch.bind(this);
      searchOverlay.addEventListener("click", this.closeListener);
    }

    else{
      if (pageOverlayElement) {
        this.closeListener = this.closeSearch.bind(this);
        pageOverlayElement.addEventListener("click", this.closeListener);
      }
    }
  

  }
  

  closeSearch() {
    event.preventDefault();
  
    if (!this.isOpen) {
      return;
    }
  
    const { element, pageOverlayElement, options } = this;
    const mainHeader = document.body.querySelector("#shopify-section-main-header");
    const announcementBar = document.body.querySelector("#shopify-section-section-announcement_bar");
    const header = document.body.querySelector("#header");
    const pageOverlaySearch = document.querySelector('.pageOverlaySearch');
  
    bodyScrollLock.enableBodyScroll(element, bodyScrollLockOptions);
  
    const transitionEnded = (event) => {
      document.body.classList.remove("search-open");
      element.removeEventListener("transitionend", transitionEnded);
    };
  
    element.addEventListener("transitionend", transitionEnded);
  
    document.body.querySelectorAll(".search").forEach((item) => {
      item.setAttribute("aria-hidden", true);
    });
  
    pageOverlayElement.classList.remove("is-visible");
    mainHeader.style.backgroundColor = "transparent";
    document.body.style.width = "100%";
  
    if (options["transparent"] && window.pageYOffset < 25) {
      header.classList.add("Header--Transparent");
    } else {
      header.classList.remove("Header--Transparent");
    }
  
    pageOverlaySearch.classList.remove('is-visible');
    document.body.classList.remove("scrollLock");
  
    this.isOpen = false;
  }

  async onInput(event) {
    this.allPredictiveSearchInstances = [];
    this.lastInputValue = event.target.value;
  
    this.searchResultsElement.style.opacity = 0;
    this.clearSearchButton.setAttribute("aria-hidden", "false");
  
    if (event.target.getAttribute("data-value") && this.lastInputValue === 0) {
      this.lastInputValue = event.target.getAttribute("data-value");
      const el = this.element.querySelector("searchInput");
  
      el.setAttribute("value", this.lastInputValue);
      el.value = this.lastInputValue;
    } else {
      if (event.keyCode === 13) {
        return;
      }
  
      if (this.lastInputValue === "") {
        this.initialSearchLayout.style.opacity = 0;
        this.resetSearch();
        return;
      }
    }
  
    try {
      const response = await fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(this.lastInputValue)}&resources[limit_scope]=each&section_id=search-predictive`);
  
      if (!response.ok) {
        throw new Error(response.status);
      }
  
      const text = await response.text();
      const resultsMarkup = new DOMParser().parseFromString(text, "text/html").querySelector("#shopify-section-search-predictive").innerHTML;
  
      // Save bandwidth keeping the cache in all instances synced
      this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
        predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
      });
  
      this.element.querySelector('.searchWrapper').innerHTML = resultsMarkup;
      this.initCarousel();
      this.element.querySelector('.searchWrapper').style.opacity = 1;
  
      if (window.theme.showRecentSearches) {
        this.recentSearches();
      }
  
      bodyScrollLock.disableBodyScroll(this.element.querySelector("[data-scrollable]"), bodyScrollLockOptions);
    } catch (error) {
      if (error?.code === 20) {
        // Code 20 means the call was aborted
        return;
      }
  
      throw error;
    }
  }
  

  loadRecommendations() {
    const _this = this;
    const targetProduct = this.options["product"];
    const recommendationsUrl =
      `${window.routes.localeRootUrl}/recommendations/products?section_id=helper-search_suggested&product_id=${targetProduct}&limit=8`;

    return fetch(recommendationsUrl)
      .then(function (response) {
        return response.text().then(function (content) {
          const container = document.createElement("div");
          const contentWrapper = document.createElement("div");
          contentWrapper.innerHTML = content;
          container.innerHTML = contentWrapper.innerHTML;

          const newSwiper = _this.element.querySelector(".searchInitial--Products");
          newSwiper.innerHTML = container.querySelector(".helper--searchSuggested").innerHTML;

          _this.initCarousel();
          new AddToCart(_this.element);
        });
      })
      .catch(function (error) {
        console.error("Error loading recommendations:", error);
      });
  }

  resetSearch() {
    this.searchResultsElement.innerHTML = this.initialSearchLayout.innerHTML;

    this.searchInputElement.value = "";
    this.searchInputElement.removeAttribute("value");

    if (window.theme.showRecentSearches) {
      this.getRecentSearches();
    }
    if (window.theme.showSuggestedSearches) {
      this.getSuggestedSearches();
    }
    if (this.options["product"] && this.options["collection"] == "") {
      this.loadRecommendations();
    }

    this.initCarousel();
    this.searchResultsElement.style.opacity = 1;
    this.clearSearchButton.setAttribute("aria-hidden", "true");
  }

  getSuggestedSearches() {
    var appendString = "";
    const arr = this.options.items;

    if (arr.length == 0) {
      return;
    }
    arr.sort(function () {
      return 0.5 - Math.random();
    });
    var filtred = arr.filter(function (a) {
      if (!a.includes("_")) {
        return a;
      }
    });

    var i;
    appendString = "";
    for (i = 0; i < 5; i++) {
      if (filtred[i]) {
        var filteredResult = filtred[i].replace(":", " ");
        filteredResult = filteredResult.replace("-", " ");
        appendString =
          appendString +
          "<li tabindex='0' class='u-p4' data-action='search-string' data-value='" +
          filteredResult +
          "'>" +
          filteredResult +
          "</li>";
      }
    }
    var appElement = this.searchElement.querySelector(
      ".Search--Suggested__results"
    );
    appElement.innerHTML = appendString;
  }
  recentSearches() {
    if (this.lastInputValue.length > 3) {
      var searchTerm = JSON.parse(localStorage.getItem("searchTerms") || "[]");
      if (!searchTerm.includes(this.lastInputValue)) {
        searchTerm.unshift(this.lastInputValue);
      }

      // Then, we save the search info into the local storage, by keeping only the 5 most recent
      try {
        localStorage.setItem(
          "searchTerms",
          JSON.stringify(searchTerm.slice(0, 5))
        );
      } catch (error) { }
    }
  }

  getRecentSearches() {
    let appendString = "";
    const items = JSON.parse(localStorage.getItem("searchTerms") || "[]");
    let elementToAdd = this.element.querySelector(".search--recentResults");
    if (items.length > 0) {
      items.forEach((id, index) => {
        appendString =
          appendString +
          "<li tabIndex='0' class='u-p4 ' data-action='search-string' data-value='" +
          id +
          "'>" +
          id +
          "</li>";
      });

      elementToAdd.innerHTML = appendString;
    } else {
      this.querySelector('#predictiveSearch--recentSearches').style.display = "none"
      const twoColumns = this.querySelector('.predictiveSearch--twoColumns');
      if (twoColumns) twoColumns.classList.remove('predictiveSearch--twoColumns');
    }
  }

  onRecentSearchClick(event) {

    const clickedSearchWord = event.target.getAttribute("data-value");
    if (clickedSearchWord) {
      // Set the clicked word in the search input
      this.searchInputElement.value = clickedSearchWord;
      this.searchInputElement.focus();

      // Trigger a search with the clicked word (if needed)
      this.onInput({ target: this.searchInputElement });
    }
  }

}
customElements.define("search-bar", SearchBar);

class Search extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    // Find result elements
    this.resultElements = this.element.querySelectorAll(".Search--Result");

    this.filterSearchBars = this.element.querySelector(".templateSearch .FilterBar");
    // Find buttons to toggle between products and articles
    this.openProductBtn = this.element.querySelector("#productBtn");
    this.openArticleBtn = this.element.querySelector("#articleBtn");
    new AddToCart(this.element);
    this.bindEvents();

    // Find number of products and articles and display them
    const productElements = this.element.querySelectorAll(".SearchProductWrapper");
    const productNumber = productElements.length;
    const itemNumber = this.element.querySelector(".itemNumber");
    if (productNumber === 0) {
      this.filterSearchBars.style.display = "none";
    }
    if (itemNumber) {
      itemNumber.innerHTML = productNumber;
      if (productNumber === 0) {

        this.openProductBtn.style.display = "none";
      }
    }

    const articleElements = this.element.querySelectorAll(".article-wrapper");
    const articleNumber = articleElements.length;
    const itemNumber_2 = this.element.querySelector(".itemNumber_2");
    if (itemNumber_2) {
      itemNumber_2.innerHTML = articleNumber;
      if (articleNumber === 0) {
        this.openArticleBtn.style.display = "none";
      }
    }

    if (productNumber !== 0) {
      this.showProducts();
    }
    if (productNumber === 0 && articleNumber !== 0) {
      this.showArticles();
    }
  }

  bindEvents() {
    // Toggle between products and articles when buttons are clicked
    this.delegateElement.on(
      "click",
      '[data-action="toggle-products"]',
      this.showProducts.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="toggle-articles"]',
      this.showArticles.bind(this)
    );
  }

  showProducts() {



    // Show product elements and hide article elements
    const productElements = this.element.querySelectorAll(".SearchProductWrapper");
    const productNumber = productElements.length;
    if (!productElements.length) {
      return;
    }
    const articleElements = this.element.querySelectorAll(".article-wrapper");
    articleElements.forEach((article) => {
      article.classList.add("hidden");
    });
    productElements.forEach((product) => {
      product.classList.remove("hidden");
    });
    //show filter and searh bar
    if (productNumber === 0) {
      this.filterSearchBars.style.display = "none";
    } else {
      this.filterSearchBars.style.display = "flex";
    }

    // Update button styles
    this.openProductBtn.classList.add("active");
    this.openArticleBtn.classList.remove("active");

    this.openProductBtn.classList.add("underline");
    this.openArticleBtn.classList.remove("underline");

    this.announceSearchResults('products', productNumber);
  }

  showArticles() {
    //hide filters and search

    this.filterSearchBars.style.display = "none";
    // Show article elements and hide product elements
    const articleElements = this.element.querySelectorAll(".article-wrapper");
    if (!articleElements.length) {
      return;
    }
    const productElements = this.element.querySelectorAll(".SearchProductWrapper");
    productElements.forEach((product) => {
      product.classList.add("hidden");
    });
    articleElements.forEach((article) => {
      article.classList.remove("hidden");
    });

    // Update button styles
    this.openProductBtn.classList.remove("active");
    this.openArticleBtn.classList.add("active");

    this.openProductBtn.classList.remove("underline");
    this.openArticleBtn.classList.add("underline");

    this.announceSearchResults('articles', articleElements.length);
  }

  announceSearchResults(type, count) {
    const liveRegion = document.getElementById('search-results-live-region');
    if (!liveRegion || !window.searchStrings) return;

    const message = type === 'articles'
      ? window.searchStrings.tabArticles.replace('COUNT', count)
      : window.searchStrings.tabProducts.replace('COUNT', count);

    liveRegion.textContent = '';
    requestAnimationFrame(() => {
      liveRegion.textContent = message;
    });
  }
}

customElements.define("search-component", Search);

class ContactSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.bindEvents();
    this.toggleButton();

  }

  bindEvents() {
    this.delegateElement.on(
      "change",
      "[data-state='required']",
      this.toggleButton.bind(this)
    );
  }

  toggleButton() {
    this.buttonState = true;

    var allBoxes = this.element.querySelectorAll("[data-state='required']");
    allBoxes.forEach((item, i) => {
      if (item.checked == false) {
        this.buttonState = false;
      }
    });

    const mojgumb = this.element.querySelector(".Contact-Btn");

    if (this.buttonState == true) {
      this.element.querySelector(".Contact-Btn").removeAttribute("disabled");
    } else {
      this.element.querySelector(".Contact-Btn").setAttribute("disabled", true);
    }
  }


}





customElements.define("contact-section", ContactSection);

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]'
      ),
    };
    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}

customElements.define("localization-form", LocalizationForm);

class PickupAvailability extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    if (!this.hasAttribute("available")) return;
    this.fetchAvailability(this.dataset.variantId);
  }

  fetchAvailability(variantId) {
    const variantSectionUrl = `${window.routes.localeRootUrl}/variants/${variantId}/?section_id=helper-pickup`;

    fetch(variantSectionUrl)
      .then((response) => response.text())
      .then((text) => {
        const sectionInnerHTML = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector(".shopify-section");
        this.renderPreview(sectionInnerHTML);
      })
      .catch((e) => {
        this.renderError();
      });
  }

  renderError() { }

  renderPreview(sectionInnerHTML) {
    this.element.innerHTML = "";

    this.element.appendChild(
      sectionInnerHTML.querySelector(".LocalPickup_--Wrapper")
    );
    if (sectionInnerHTML.querySelector("#LocalPickup")) {
      this.element.appendChild(sectionInnerHTML.querySelector("#LocalPickup"));
      new Drawer(this.element.querySelector("#LocalPickup"));
    }
  }
}

customElements.define("pickup-availability", PickupAvailability);

class CartNote extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.textarea = this.element.querySelector("textarea");
    this.button = this.element.querySelector(".CartNote--Submit");
    this.noteSucess = this.element.querySelector(".cartNote--Success");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action='update-note']",
      this.updateNote.bind(this)
    );

    this.delegateElement.on(
      "click",
      "[data-action='edit-note']",
      this.editNote.bind(this)
    );
  }
  editNote() {
    this.textarea.removeAttribute("disabled");
    this.button.innerText = window.cartStrings.enter_note;
    this.button.setAttribute("data-action", "update-note");
    this.textarea.focus();
    this.noteSucess.style.visibility = "hidden";
    this.noteSucess.style.opacity = "0";
  }

  updateNote() {
    var _this = this;
    this.value = this.textarea.value;

    fetch(window.routes.localeRootUrl + "/cart/update.js", {
      body: JSON.stringify({ note: this.value }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {
        if (_this.value == "") {
          return;
        }
        _this.textarea.setAttribute("disabled", "disabled");
        _this.button.innerText = window.cartStrings.note_change;
        _this.button.setAttribute("data-action", "edit-note");
        _this.noteSucess.style.visibility = "visible";
        _this.noteSucess.style.opacity = "1";
      }
    });
  }
}

customElements.define("cart-note", CartNote);

class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.isOpen = false;
    this.inertElements = [];
    this.openTimeout = null;

    this.closeNewsletter = this.closeNewsletter.bind(this);
    this.suppressOnCartListener = this.suppressOnCartListener.bind(this);
    document.addEventListener("cart-drawer:open", this.suppressOnCartListener);
    this.delegateElement.on(
      "click",
      '[data-action="close-modal"]',
      this.closeNewsletter
    );

    if (this.options.edit_mode) {
      this.options.delay = 0;
      this.scheduleOpen();
    } else {
      this.handleOpenOptions();
    }

    if (
      window.location.href.indexOf("form_type=customer#popupForm") > -1 ||
      window.location.href.indexOf("customer_posted=true#popupForm") > -1 ||
      window.location.href.indexOf("customer_posted=true#nsltForm*") > -1
    ) {
      this.options.delay = 0;
      this.scheduleOpen();
    }
  }

  shouldSuppressPopup() {
    const path = window.location.pathname;
    if (path.includes("/cart") || path.includes("/checkouts")) {
      return true;
    }

    const cart = document.getElementById("cart");
    if (
      cart &&
      (cart.getAttribute("aria-hidden") === "false" ||
        cart.getAttribute("aria-expanded") === "true")
    ) {
      return true;
    }

    return false;
  }

  suppressOnCartListener() {
    if (this.openTimeout) {
      clearTimeout(this.openTimeout);
      this.openTimeout = null;
    }

    if (this.isOpen) {
      this.closeNewsletter();
    }
  }

  handleOpenOptions() {
    const localKey = localStorage.getItem("popup-seen");

    if (this.options.show_only_once && localKey === "true") {
      return;
    }

    if (localKey !== "true") {
      if (this.options.scroll_amount > 0) {
        document.addEventListener("scroll", this.scrollListener);
      } else {
        this.scheduleOpen();
      }
    }
  }

  scrollListener = () => {
    const body = document.body;
    const html = document.documentElement;

    const docHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );

    const percScrolled = (window.scrollY / docHeight) * 100;

    if (percScrolled >= this.options.scroll_amount) {
      this.scheduleOpen();
    }
  };

  scheduleOpen() {
    if (this.shouldSuppressPopup()) {
      document.removeEventListener("scroll", this.scrollListener);
      return;
    }

    document.removeEventListener("scroll", this.scrollListener);

    if (this.openTimeout) {
      clearTimeout(this.openTimeout);
    }

    this.openTimeout = setTimeout(() => {
      this.openTimeout = null;
      this.showPopup();
    }, 1000 * this.options.delay);
  }

  openNewsletter() {
    this.scheduleOpen();
  }

  showPopup() {
    if (this.isOpen || this.shouldSuppressPopup()) {
      return;
    }

    this.lastActiveElement = document.activeElement;
    this.isOpen = true;
    this.element.setAttribute("aria-hidden", "false");
    this.pageOverlayElement.classList.add("is-visible");
    this.inertElements = drawerPageInert.acquire(this.element);
    bodyScrollLock.disableBodyScroll(this.element, bodyScrollLockOptions);
    this.pageOverlayElement.addEventListener("click", this.closeNewsletter);
    localStorage.setItem("popup-seen", true);
    this.bindEscapeKey();

    const initialFocus =
      this.element.querySelector('input[type="email"]') ||
      this.element.querySelector(".closeNewsletterPopup") ||
      this.element;

    requestAnimationFrame(() => {
      trapFocus(this.element, initialFocus);
    });
  }

  bindEscapeKey() {
    this._escapeListener = (keydownEvent) => {
      if (keydownEvent.key !== "Escape" || !this.isOpen) {
        return;
      }

      keydownEvent.preventDefault();
      this.closeNewsletter(keydownEvent);
    };

    document.addEventListener("keydown", this._escapeListener); // delegate-exempt: close newsletter dialog
  }

  unbindEscapeKey() {
    if (!this._escapeListener) {
      return;
    }

    document.removeEventListener("keydown", this._escapeListener);
    this._escapeListener = null;
  }

  closeNewsletter(event) {
    if (event) {
      event.preventDefault();
    }

    this.isOpen = false;
    this.element.setAttribute("aria-hidden", "true");
    this.pageOverlayElement.classList.remove("is-visible");
    bodyScrollLock.clearAllBodyScrollLocks();
    this.pageOverlayElement.removeEventListener("click", this.closeNewsletter);
    document.removeEventListener("scroll", this.scrollListener);
    this.unbindEscapeKey();
    drawerPageInert.release(this.inertElements);
    this.inertElements = [];
    removeTrapFocus(this.lastActiveElement);
    this.lastActiveElement = null;

    if (this.openTimeout) {
      clearTimeout(this.openTimeout);
      this.openTimeout = null;
    }
  }
}

customElements.define("newsletter-popup", NewsletterPopup);

class AccountHandler extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.drawer = new Drawer(this.element.querySelector('#accountDrawer'));
    this.bindEvents();



  }
  bindEvents() {

    this.delegateElement.on('click', '[data-action="toggle-tab"]', this.toggleTab.bind(this));
    this.delegateElement.on('click', '[data-action="submit-login"]', this.submitLogin.bind(this));
    this.delegateElement.on('click', '[data-action="submit-register"]', this.submitRegistration.bind(this));
    this.delegateElement.on('click', '[data-action="toggle-recovery"]', this.toggleRecovery.bind(this));
    this.delegateElement.on('click', '[data-action="submit-recovery"]', this.accountRecover.bind(this));

  }

  toggleRecovery() {
    event.preventDefault();
    const id = event.target.dataset.id;

    if (id == "recoverFlex") {
      this.element
        .querySelector("#recoverFlex")
        .setAttribute("aria-visible", "true");
      this.element
        .querySelector("#loginFlex")
        .setAttribute("aria-visible", "false");
    } else {
      this.element
        .querySelector("#recoverFlex")
        .setAttribute("aria-visible", "false");
      this.element
        .querySelector("#loginFlex")
        .setAttribute("aria-visible", "true");
    }
  }

  accountRecover(event) {
    event.preventDefault();
    const _this = this;
    const registrationEndpoint = "/account/recover";

    // Create the request body with the registration data
    const requestBody = {
      email: this.element.querySelector("#RecoverEmail").value,
    };

    event.target.querySelector(".ButtonText").style.visibility = "hidden";
    event.target.querySelector(".itemLoader").classList.add("is-visible");

    // Send the AJAX request
    (async function () {
      try {
        const response = await fetch(registrationEndpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        });

        const responseText = await response.text();
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = responseText;

        if (responseText.indexOf("RecoverEmail-email-error") !== -1) {
          _this.element.querySelector(
            "#recoverFlex .accountDrawer--ErrorSpace"
          ).innerHTML = tempDiv.querySelector(
            "#RecoverEmail-email-error"
          ).innerHTML;
        } else if (responseText.indexOf("recoverSuccess") !== -1) {
          _this.element.querySelector(
            "#recoverFlex .accountDrawer--SuccessSpace"
          ).innerHTML = tempDiv.querySelector("#recoverSuccess").innerHTML;
        }

        event.target.querySelector('.ButtonText').style.visibility = "visible";
        event.target.querySelector('.itemLoader').classList.remove('is-visible');
        if(document.querySelector('#header').offsetHeight > 0){
          document.documentElement.style.setProperty('--header-height', document.querySelector('#header').offsetHeight + 'px');
        }

      } catch (error) {
        console.log(
          "An error occurred during the registration request:",
          error
        );
      }
    })();
  }

  submitRegistration(event) {
    event.preventDefault();
    const _this = this;
    const registrationEndpoint = "/account";

    // Create the request body with the registration data
    const requestBody = {
      customer: {
        first_name: this.element.querySelector(
          "#register #RegisterForm-FirstName"
        ).value,
        last_name: this.element.querySelector(
          "#register #RegisterForm-LastName"
        ).value,
        email: this.element.querySelector("#register #RegisterForm-email")
          .value,
        password: this.element.querySelector("#register #RegisterForm-password")
          .value,
      },
    };

    event.target.querySelector(".ButtonText").style.visibility = "hidden";
    event.target.querySelector(".itemLoader").classList.add("is-visible");

    // Send the AJAX request
    (async function () {
      try {
        const response = await fetch(registrationEndpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        });

        const responseText = await response.text();

        if (responseText.indexOf("registerErrors") !== -1) {
          console.log("Error occurred during registration");
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = responseText;

  
    
          _this.element.querySelector(
            "#register .accountDrawer--ErrorSpace"
          ).innerHTML = tempDiv.querySelector(".registerErrors").innerHTML;
          const transitionEnded = function transitionEnded(event) {
            document.documentElement.style.setProperty('--header-height', document.querySelector('#header').offsetHeight + 'px');
            document.querySelector('#header').removeEventListener("transitionend", transitionEnded);
          };
      
          document.querySelector('#header').addEventListener("transitionend", transitionEnded);
        } else {
    
          location.href = window.routes.account_url;
        }

        event.target.querySelector(".ButtonText").style.visibility = "visible";
        event.target
          .querySelector(".itemLoader")
          .classList.remove("is-visible");
          document.documentElement.style.setProperty('--header-height', document.querySelector('#header').offsetHeight + 'px');
      } catch (error) {
        console.log(
          "An error occurred during the registration request:",
          error
        );
      }
    })();
  }

  submitLogin(event) {
    event.preventDefault();
    const _this = this;
    const loginEndpoint = "/account/login";

    // Create the request body with the login credentials
    const requestBody = {
      customer: {
        email: this.element.querySelector("#customer_login #CustomerEmail")
          .value,
        password: this.element.querySelector(
          "#customer_login #CustomerPassword"
        ).value,
      },
    };

    event.target.querySelector(".ButtonText").style.visibility = "hidden";
    event.target.querySelector(".itemLoader").classList.add("is-visible");

    // Send the AJAX request
    (async function () {
      try {
        const response = await fetch(loginEndpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        });

        const responseText = await response.text();

        if (responseText.indexOf("loginError") !== -1) {
          console.log("Incorrect email or password");
          const tempDiv = document.createElement("div");

          tempDiv.innerHTML = responseText;

          _this.element.querySelector(
            "#login .accountDrawer--ErrorSpace"
          ).innerHTML = tempDiv.querySelector(".AlertError").innerHTML;
          event.target.querySelector(".ButtonText").style.visibility =
            "visible";
          event.target
            .querySelector(".itemLoader")
            .classList.remove("is-visible");
          
        } else {
  
          location.href = window.routes.account_url;
        }
        const transitionEnded = function transitionEnded(event) {
          document.documentElement.style.setProperty('--header-height', document.querySelector('#header').offsetHeight + 'px');
          document.querySelector('#header').removeEventListener("transitionend", transitionEnded);
        };
    
        document.querySelector('#header').addEventListener("transitionend", transitionEnded);

        
      } catch (error) {
        console.log("An error occurred during the login request:", error);
      }
    })();
  }

  toggleTab(event) {
    const id = event.target.dataset.id;
    const allTabs = this.element.querySelectorAll(
      '.accountDrawer--Tab[aria-expanded="true"]'
    );
    const allContent = this.element.querySelectorAll(".accountContent");

    allTabs.forEach((tab) => {
      tab.setAttribute("aria-expanded", "false");
    });

    event.target.setAttribute("aria-expanded", "true");

    allContent.forEach((content) => {
      content.setAttribute("aria-visible", "false");
    });

    const content = this.element.querySelector(`#${id}`);
    if (content) {
      content.setAttribute("aria-visible", "true");
    }
  }
}

customElements.define("account-handler", AccountHandler);

class LocalizationSelectors extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    let responsive = new Responsive();
    let breakpoint = responsive.getCurrentBreakpoint();
    var selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");
    var location = this.element.getAttribute("data-settings");

    if (location == "sidebarMenu") {
      var additionalOverlay = true;
    } else {
      var additionalOverlay = false;
    }
    if (breakpoint != "phone" && breakpoint != "tablet") {
      if (selectBoxes.length > 0) {
        selectBoxes.forEach((item, i) => {
          new RevolutionSelectbox(item);
        });
      }
    } else {
      if (selectBoxes.length > 0) {
        selectBoxes.forEach((item, i) => {
          new RevolutionSelectbox(item, true, additionalOverlay);
        });
      }
    }
  }
}
customElements.define("localization-selectors", LocalizationSelectors);

class FormShowBlog extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.formBlog = this.element.querySelector(".comments--form");
    this.successMessage = this.element.querySelector(".successMessage");
    this.bindEvents();
    this.handleAfterState();

    if (window.location.href.indexOf("comments") != -1) {
      const buttonWrite = this.element.querySelectorAll(
        ".comments--buttonWrite"
      );
      buttonWrite.forEach((btn) => {
        btn.style.display = "none";
      });
      return;
    }
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="handle-hidden"]',
      this.toggleEffect.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="load-more"]',
      this.loadMore.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="copy"]',
      this.copy.bind(this)
    );
  }

  copy() {
    var url = document.querySelector("#currentUrl");
    url.value = window.location.href;

    this.successMessage.classList.remove("hidden");
    setTimeout(() => {
      this.successMessage.classList.add("hidden");
    }, 3000);

    navigator.clipboard.writeText(url.value);
  }

  handleAfterState() {
    if (window.location.href.indexOf("#comment_form") > -1) {
      this.element
        .querySelector(".comments--buttonWrite")
        .setAttribute("aria-hidden", "true");
      this.formBlog.classList.remove("comments--formHide");
    }
  }

  toggleEffect(event, target) {
    const form = this.element.querySelector("#comment_form");
    target.style.display = "none";
    form.setAttribute("aria-hidden", "false");
    this.formBlog.classList.remove("comments--formHide");
  }

  loadMore(event, target) {
    const _this = this;
    let dataHref = target.getAttribute("data-href");

    return fetch(window.routes.localeRootUrl + dataHref, {
      credentials: "same-origin",
      method: "GET",
    }).then(function (content) {
      content.text().then(function (htmlData) {
        let html = new DOMParser().parseFromString(htmlData, "text/html");
        let newComments = html.querySelectorAll(".ArticleComments--Comment");

        let curDocument = _this.element.querySelector(".ArticleComments");
        curDocument.append(...newComments);
        let dataHref = html.querySelector(".comments--buttonFooter");

        if (dataHref) {
          dataHref = dataHref.dataset.href;
          _this.element.querySelector(".comments--buttonFooter").dataset.href =
            dataHref;
        } else {
          _this.element.querySelector(".comments--buttonFooter").remove();
        }
      });
    });
  }
}
customElements.define("blog-post", FormShowBlog);


class SizeGuideDrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.drawer = new Drawer(this.element.querySelector('#sizeGuide'));
  }
}
customElements.define("size-guide-drawer", SizeGuideDrawer);

class ProductCardSlider extends HTMLElement {
  constructor(elem) {
    super();
    elem ? this.element = elem : this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");
    this.delegateElement = new Delegate(this.element);

    const productId = this.element.getAttribute('data-id');
    const cardRoot = this.element.closest('.cardWrapper') || this.element;
    this.prevEl =
      this.element.querySelector('.swiperButtonPrevious') ||
      cardRoot.querySelector(`.swiperPrevId--${productId}`);
    this.nextEl =
      this.element.querySelector('.swiperButtonNext') ||
      cardRoot.querySelector(`.swiperNextId--${productId}`);

    this.carousel = new Swiper(this.carouselElement, {
      slidesPerView: "auto",
      spaceBetween: 0,
      preloadImages: false,
      resistanceRatio: 0,
      nested: true,
      navigation: {
        nextEl: this.nextEl || `.swiperNextId--${productId}`,
        prevEl: this.prevEl || `.swiperPrevId--${productId}`
      },
      scrollbar: {
        el: this.element.querySelector(".swiper-scrollbar"),
        draggable: true
      },
      a11y: {
        enabled: false
      }
    });

    this.swiper = this.carouselElement.swiper;
    this.navRoot = cardRoot.querySelector('.cardWrapper--Nav');

    if (this.swiper.slides.length > 1) {
      this.element.style.backgroundColor = 'var(--background_color)';
    }

    if (this.navRoot && this.swiper.slides.length <= 1) {
      this.navRoot.hidden = true;
    }

    this.updateSlideAccessibility();
    this.swiper.on('slideChange', () => {
      this.updateSlideAccessibility();
    });

    this.bindEvents();
  }

  updateNavigationAccessibility() {
    if (!this.prevEl || !this.nextEl) return;

    const totalSlides = this.swiper.slides.length;
    const atStart = this.swiper.activeIndex <= 0;
    const atEnd = this.swiper.activeIndex >= totalSlides - 1;
    // Disable only when that direction isn't available (keeps operable arrows in tab order).
    const prevDisabled = totalSlides <= 1 || atStart;
    const nextDisabled = totalSlides <= 1 || atEnd;

    this.prevEl.disabled = prevDisabled;
    this.prevEl.setAttribute('aria-disabled', prevDisabled ? 'true' : 'false');
    this.prevEl.classList.toggle('swiper-button-disabled', prevDisabled);

    this.nextEl.disabled = nextDisabled;
    this.nextEl.setAttribute('aria-disabled', nextDisabled ? 'true' : 'false');
    this.nextEl.classList.toggle('swiper-button-disabled', nextDisabled);
  }

  updateNavigationLabels() {
    if (!this.prevEl || !this.nextEl) return;

    const current = this.swiper.activeIndex + 1;
    const total = this.swiper.slides.length;
    const positionTemplate = this.element.getAttribute('data-position-label') || '';
    const nextBase = this.element.getAttribute('data-next-label') || '';
    const prevBase = this.element.getAttribute('data-prev-label') || '';
    const positionLabel = positionTemplate
      .replace('CURRENT', current)
      .replace('TOTAL', total);

    this.nextEl.setAttribute(
      'aria-label',
      positionLabel ? `${nextBase}. ${positionLabel}` : nextBase
    );
    this.prevEl.setAttribute(
      'aria-label',
      positionLabel ? `${prevBase}. ${positionLabel}` : prevBase
    );
  }

  updateSlideAccessibility() {
    const activeIndex = this.swiper.activeIndex;

    this.swiper.slides.forEach((slide, index) => {
      const isActive = index === activeIndex;
      slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');

      if (isActive) {
        slide.removeAttribute('inert');
      } else {
        slide.setAttribute('inert', '');
      }
    });

    this.updateNavigationAccessibility();
    this.updateNavigationLabels();
  }

  bindEvents() {
    this.delegateElement.on('click', "[data-action='no-redirect']", this.redirect.bind(this));
    this.delegateElement.on('mouseenter', "[data-action='disable-parent']", () => this.element.dispatchEvent(new CustomEvent('product-slider:disable', { bubbles: true })));
    this.delegateElement.on('mouseleave', "[data-action='disable-parent']", () => this.element.dispatchEvent(new CustomEvent('product-slider:enable', { bubbles: true })));
    this.delegateElement.on('touchstart', "[data-action='disable-parent']", () => this.element.dispatchEvent(new CustomEvent('product-slider:disable', { bubbles: true })));
    this.delegateElement.on('touchend', "[data-action='disable-parent']", () => this.element.dispatchEvent(new CustomEvent('product-slider:enable', { bubbles: true })));
    if (this.element.closest(".ProductRecommSwiper")) {
      this.swiper.on("slideChange", () => {
        this.updateNavigationAccessibility();
      });
    }
  }

  redirect(e) {
    e.preventDefault();
    e.stopPropagation();
    const target = e.target;
    const colorBox = target.closest?.('.Product--ColorBox');
    const image = target.closest?.('img');

    if (colorBox) {
      const index = parseInt(colorBox.getAttribute('index'), 10);
      if (index) this.swiper.slideTo(index);
    } else if (image) {
      const targetURL = image.getAttribute('data-href');
      if (targetURL) window.location.href = targetURL;
    }
  }
}
customElements.define("product-card-slider", ProductCardSlider);

class MainArticleSwiper extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);
  }
}
customElements.define("main-article-swiper", MainArticleSwiper);


class BlogSwiper extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);
  }
}
customElements.define("blog-animation", BlogSwiper);

class AnimationText extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    if(this.element.dataset.animationMobile == 'false' && new Responsive().matchesBreakpoint('pocket')) return;
    
    if (this.element.dataset.animationDesktop == 'false' && new Responsive().matchesBreakpoint('lap-and-up')) return;
    this.bind();
  }
  bind() {
    setTimeout(() => {
      // Get the original metaItem--animHolder element
      let originalAnimHolder = this.querySelector('.metaItem--animHolder');
      // Create a deep clone of the original animHolder element
      let clonedAnimHolder = originalAnimHolder.cloneNode(true);
      clonedAnimHolder.setAttribute("aria-hidden", "true");
      // Add the cloned animHolder element to the parent div
      let metaItemContent = this.querySelector('.metaItem--content');
      metaItemContent.appendChild(clonedAnimHolder);
      const animArray = this.querySelectorAll('.metaItem--animHolder');
      let i = 0;
      animArray.forEach((item) => {
        item.classList.add(`animHolder--${i}`);
        i++;
      })
      this.querySelector('.metaItem--animHolder.animHolder--1').style.opacity = 0;
      setTimeout(() => {
        this.querySelector('.metaItem--animHolder.animHolder--1').style.opacity = 1;
      }, 15000);
    }, 50);
  }
}
customElements.define("animation-text", AnimationText);

sessionStorage.setItem('firstLoad', true);
class FavoritesDrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.sidebarDrawer = new Drawer(this.element);
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.loader = this.element.querySelector(".spinningLoader");
    this.cartCount = document.querySelector(".FavoritesCount");
    this.favEmpty = document.querySelector('.TopBar--FavEmpty');
    this.favFull = document.querySelector('.TopBar--FavFull');
    if (sessionStorage.getItem('firstLoad') === 'true') {
      sessionStorage.setItem('firstLoad', false);
      this.loader.classList.add("is-visible");
      this.rerenderFavorites();
    }
    this.loadRecommendations();
    this.toggleFavorites();
    this.bindEvents();
  }
  unbindEvents() {
    document.removeEventListener('favorite-product:open', this.onFavoritesOpenListener);

    document.removeEventListener(
      'click',
      this._addToFavoritesL
    );

  }
  bindEvents() {


    if (!document.body.classList.contains('listener')) {
      this.onFavoritesOpenListener = this.onFavoritesOpen.bind(this);
      this._addToFavoritesL = this.addToFavorites.bind(this);

      this.delegateBody.on('click', '[data-action="toggle-favorites"]', this._addToFavoritesL);
      document.body.classList.add('listener');
      document.addEventListener('favorite-product:open', this.onFavoritesOpenListener);
      document.addEventListener('favorites:toggle', this.toggleFavorites.bind(this));
    } this.calculateMaxHeightListener = this.maxHeight.bind(this);
    window.addEventListener("resize", this.calculateMaxHeightListener);



  }

  onFavoritesOpen() {


    this.sidebarDrawer.isOpen = true;
  }

  maxHeight() {
    var header = this.element.querySelector(".Drawer--Header");
    if (header) {
      var headerH = header.offsetHeight;
    }

    this.element.querySelector(".CartItems--Wrapper").style.height =
      window.innerHeight - headerH + "px";
  }

  getSearchQueryStrings() {
    var items = JSON.parse(localStorage.getItem("productFavorites") || "[]");
    // Filter out null values
    items = items.filter(id => id !== null);
    const bucketSize = 10.0;
    const idBuckets = [];
    items.forEach((id, index) => {
      const key = Math.floor(index / bucketSize);
      if (!idBuckets[key]) {
        idBuckets[key] = [];
      }
      idBuckets[key].push(id);
    });
    return idBuckets.reduce((acc, vall) => {
      const string = vall
        .filter(id => id !== null) // Filter out null values
        .map(function (id) {
          return "id:" + id;
        })
        .join(" OR ");

      if (string) {
        acc.push(string); // Add the string to the result array if it's not empty
      }
      return acc;
    }, []);
  }

  hideLoader(noDelay) {
    let delay;
    noDelay ? delay = 0 : delay = 500;
    setTimeout(() => {
      this.loader.classList.remove("is-visible");
    }, delay);
  }

  rerenderFavorites(openfavorites) {
    var _this32 = this;
    var queryStrings = this.getSearchQueryStrings();
    const promises = [];
    if(queryStrings.length == 0) this.favFull.style.opacity = 0;
    else this.favFull.style.opacity = 1;
    
    if (queryStrings.length == 0 && !openfavorites) {

      fetch("/?section_id=main-favorites_drawer").then(function (content) {
        content.text().then(function (html) {
          _this32.replaceContentFav(html);
          _this32.loadRecommendations();
        });
      });

    }
    queryStrings.forEach((string) => {
      promises.push(
        fetch("/search?view=favorites&type=product&q=" + string, {
          credentials: "same-origin",
          method: "GET",
        })
      );
    });
    promises.reduce(async (acc, val, index) => {
      const content = await val.then((response) => response.text());
      const container = this.element;
      if (!container.length) {
        _this32.replaceContentFav(content);
        _this32.maxHeight();
      }
    }, Promise.resolve());

    return Promise.resolve();
  }

  replaceContentFav(html) {
    var tempElement = document.createElement("div");
    tempElement.innerHTML = html;
    var cartNodeParent = this.element.querySelector(".CartDrawer .CartItems--Wrapper");

    cartNodeParent.replaceChild(
      tempElement.querySelector("#main-cart-items"),
      this.element.querySelector("#main-cart-items")
    );
    this.toggleFavorites();
    this.hideLoader();

    return true;
  }

  toggleFavorites() {
    var items = JSON.parse(localStorage.getItem("productFavorites") || "[]");
    var favorites = document.querySelectorAll('[data-action="toggle-favorites"]');
    if (this.favEmpty && this.favFull) {
      this.favFull.style.opacity = items.length > 0 ? 1 : 0;
    }
    favorites.forEach(function (item) {
      var myID = item.getAttribute("data-id");
      var isActive = items.some(function (id) {
        return String(id) === String(myID);
      });
      var addLabel = item.getAttribute("data-label-add");
      var removeLabel = item.getAttribute("data-label-remove");
      var activeIcon =
        item.querySelector(".product-favorite__icon--active") ||
        item.querySelector(".solidFavorite");
      var emptyIcon =
        item.querySelector(".product-favorite__icon--empty") ||
        item.querySelector(".emptyFavorite");

      if (isActive) {
        if (activeIcon) activeIcon.style.display = "flex";
        if (emptyIcon) emptyIcon.style.display = "none";
        item.setAttribute("state", "active");
        if (item.tagName === "BUTTON") {
          item.setAttribute("aria-pressed", "true");
        } else {
          item.removeAttribute("aria-pressed");
        }
        if (removeLabel) item.setAttribute("aria-label", removeLabel);
      } else {
        if (activeIcon) activeIcon.style.display = "none";
        if (emptyIcon) emptyIcon.style.display = "flex";
        item.setAttribute("state", "not-active");
        if (item.tagName === "BUTTON") {
          item.setAttribute("aria-pressed", "false");
        } else {
          item.removeAttribute("aria-pressed");
        }
        if (addLabel) item.setAttribute("aria-label", addLabel);
      }
    });
  }

  removeFromFavorites(productId) {
    var items = JSON.parse(localStorage.getItem("productFavorites") || "[]");
    items = items.filter((c) => c != productId);
    if (items.length == 0) this.loader.classList.add("is-visible");
    try {
      localStorage.setItem(
        "productFavorites",
        JSON.stringify(items.slice(0, 50))
      );
    } catch (error) {
      console.log(error);
    }
    var _this = this;
    this.toggleFavorites();

    this.rerenderFavorites().then(function () {
      new AddToCart(_this.element);
    });

  }

  loadRecommendations() {
    var _this = this;

    if (this.options["productId"] == "") {
      var url = "?section_id=main-helper_recommendations";
    } else {
      var url =
        window.routes.localeRootUrl +
        "/recommendations/products?section_id=main-helper_recommendations&product_id=" +
        this.options["productId"] +
        "&limit=10";
    }

    return fetch(url).then(function (response) {
      return response.text().then(function (content) {
        const container = document.createElement("div");
        if (container) container.innerHTML = content

        if (container) {
          var z = container.querySelector(".favUpsell").innerHTML;
          var x = _this.element.querySelector(".FavoritesRecommendations");
          if (x != null) {
            x.innerHTML = z;
          }
        }


        const swiper = new Swiper(".swiperUpsell", {
          // Default parameters
          slidesPerView: 2,
          spaceBetween: 0,
          navigation: false,
          loop: false,
          slidesOffsetAfter: 0,
          slidesOffsetBefore: 0,
          resistanceRatio: 0,
          hashNavigation: {
            watchState: false
          },
          pagination: {
            el: ".favoritePagination",
            type: "bullets",
            clickable: "true",
            bulletClass: "favoritePagination--Bullet",
            bulletActiveClass: "favoritePagination--ActiveBullet"
          },
          breakpoints: {
            1024: {
              slidesPerView: 2,
              spaceBetween: 0,
              slidesOffsetAfter: 0,
              slidesOffsetBefore: 0
            },
          },
        });

        new AddToCart(x);
        _this.toggleFavorites();

        if (window.theme.enableAnimations) {
          new RevolutionAnimation(_this.element);
        }
      });
    });
  }


  addToFavorites(event) {
    var _this = this;
    event.preventDefault();
    event.stopPropagation();

    var button = event.target.closest('[data-action="toggle-favorites"]');
    if (!button) return;

    var items = JSON.parse(localStorage.getItem("productFavorites") || "[]");
    if (items.length == 0) this.loader.classList.add("is-visible");
    var productId = button.getAttribute("data-id");

    // We check if the current product already exists, and if it does not, we add it at the start
    if (!items.some(function (id) { return String(id) === String(productId); }) && productId != "") {
      items.unshift(productId);
    } else {
      this.removeFromFavorites(productId, false);
      //   this._favoritesNumber();
      return;
    }
    // Then, we save the current product into the local storage, by keeping only the 50 most recent
    try {
      localStorage.setItem(
        "productFavorites",
        JSON.stringify(items.slice(0, 50))
      );
      //    this._favoritesNumber();
      this.toggleFavorites();

      this.rerenderFavorites().then(function () {
        new AddToCart(_this.element);
      });

    } catch (error) {
      // Do nothing, this may happen in Safari in incognito mode
    }
  }
}
customElements.define("favorites-drawer", FavoritesDrawer);

class ElvineInstagram extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    var images = new Array();
    var boxes = new Array();
    this.delegateElement = new Delegate(this.element);
    if (new Responsive().matchesBreakpoint('pocket')) {
      const swiper = this.element.querySelector(".swiper");
      new RevolutionSwiper(swiper);
    }
    var _this = this;
    var observer = new MutationObserver(function (mutations) {
      if (_this.element.querySelector('.instafeed-container')) {
        var allElements = _this.element.querySelectorAll('.instafeed-container');
        const allLinks = _this.element.querySelectorAll('#insta-feed a.follow');
        allElements.forEach((item, i) => {

          const img = item.querySelector('img');
          if (img) {
            images.push(img.getAttribute('data-src'));
          }
        });

        observer.disconnect();
        _this.element.querySelectorAll('.InstagramImageWrapper').forEach((item, i) => {
          item.querySelector('img').setAttribute('src', images[i]);
          item.querySelector('img').removeAttribute('srcset');
          if (allLinks[i]) {
            item.closest('a').setAttribute('href', allLinks[i].getAttribute('href'));
          }

        });
        setTimeout(() => document.querySelector('#insta-feed').style.display = "none", 50);
      }
    });
    observer.observe(document, { attributes: false, childList: true, characterData: false, subtree: true });
  }
  cleanSelector(selector) {
    (selector.match(/(#[0-9][^\s:,]*)/g) || []).forEach(function (n) {
      selector = selector.replace(n, '[id="' + n.replace("#", "") + '"]');
    });
    return selector;
  }
}
customElements.define("elvine-instagram", ElvineInstagram);


sessionStorage.setItem('firstLoadRecomm', true);
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    if (sessionStorage.getItem('firstLoadRecomm') === 'true') {
      sessionStorage.setItem('firstLoadRecomm', false);
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            const carouselElementNew = recommendations.querySelector(".swiper");
            const carouselElementOld = this.querySelector(".swiper");
            const productSliders = carouselElementNew.querySelectorAll('product-card-slider');
            carouselElementOld.parentNode.replaceChild(carouselElementNew, carouselElementOld)
            new RevolutionSwiper(carouselElementNew);
            this.swiper = carouselElementNew.swiper;
            productSliders.forEach(slider => new ProductCardSlider(slider));
            if (window.theme.enableAnimations) {
            new RevolutionAnimation(carouselElementNew);
            }
          }

        })
        .catch(e => {
          console.error(e);
        });
    }

    this.bindEvents();
  }

  bindEvents() {
    if (this.swiper) {
      this.addEventListener("product-slider:disable", () => { this.swiper.allowTouchMove = false; });
      this.addEventListener("product-slider:enable", () => { this.swiper.allowTouchMove = true; });
    }
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class CollectionMenu extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".collectionMenu");
    this.carousel = new RevolutionSwiper(this.carouselElement);

    if (this.element.classList.contains('ShowSubcategories')) {
      this.subSliderSwiper = this.element.querySelector(".collectionSubmenu");
      new RevolutionSwiper(this.subSliderSwiper);
      this.subSwiper = this.subSliderSwiper.swiper;
    }

    this.arrangeSwiper(this.element.querySelector('.collectionMenuInner[active-main="true"]'));
    this.preventFocusShift(this.carouselElement);
    if (this.subSliderSwiper) this.preventFocusShift(this.subSliderSwiper);
  }

  // Swiper a11y/native focus-scroll slide the focused item to the start,
  // which shoves the whole collection menu left when tabbing to the 2nd+ item.
  preventFocusShift(swiperEl) {
    if (!swiperEl) return;

    let lockedTranslate = null;

    swiperEl.addEventListener("keydown", (event) => {
      if (event.key !== "Tab") return;
      const swiper = swiperEl.swiper;
      lockedTranslate = swiper && typeof swiper.getTranslate === "function"
        ? swiper.getTranslate()
        : 0;
    }, true);

    swiperEl.addEventListener("focusin", (event) => {
      swiperEl.scrollLeft = 0;
      swiperEl.scrollTop = 0;
      const wrapper = swiperEl.querySelector(".swiper-wrapper");
      if (wrapper) {
        wrapper.scrollLeft = 0;
        wrapper.scrollTop = 0;
      }

      const swiper = swiperEl.swiper;
      const slide = event.target.closest(".swiper-slide");
      if (!swiper || !slide) return;

      const slideRect = slide.getBoundingClientRect();
      const viewRect = swiperEl.getBoundingClientRect();
      const fullyVisible =
        slideRect.left >= viewRect.left - 1 &&
        slideRect.right <= viewRect.right + 1;

      if (fullyVisible && lockedTranslate !== null && typeof swiper.setTranslate === "function") {
        swiper.setTranslate(lockedTranslate);
        if (typeof swiper.updateActiveIndex === "function") swiper.updateActiveIndex();
        if (typeof swiper.updateSlidesClasses === "function") swiper.updateSlidesClasses();
        return;
      }

      if (!fullyVisible) {
        const index = Array.prototype.indexOf.call(swiper.slides, slide);
        if (index >= 0) swiper.slideTo(index);
      }
    }, true);
  }

  arrangeSwiper(elem) {
    if(!elem) return;

    this.subSwiper.removeAllSlides();
    if (elem.children.length > 0) {
      const newSlides = Array.from(elem.children);
      newSlides.forEach(newSlide => this.subSwiper.appendSlide(`<div class="swiper-slide collectionMenu--Tabs">${newSlide.outerHTML}</div>`));
      this.subSwiper.update();
      this.subSliderSwiper.classList.remove('hidden');
    } else {
      this.subSliderSwiper.classList.add('hidden');
    }
  }
}
customElements.define("collection-menu", CollectionMenu);



class HeadingText extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    if (this.element.dataset.action == "resize-event") {
      this.bindEvents();
      if (new Responsive().matchesBreakpoint("lap-and-up")) {
        this.resizeHeading();
      }
    }

  }

  bindEvents() {
    if (new Responsive().matchesBreakpoint("lap-and-up")) {
      const self = this;
      window.addEventListener('resize', function () {
        self.resizeHeading();
      }, true);
    }

  }

  resizeHeading() {
    const allItems = this.element.querySelectorAll('.headingSubheadingText--gridWrapper');

    allItems.forEach((item) => {
      let itemHeight = 0;
      let itemChange;
      const headingSubheadingGridHeading = item.querySelectorAll('.headingSubheading--GridHeading');

      headingSubheadingGridHeading.forEach((subitem) => {

        if (subitem.childNodes.length > 1) {
          const rect = subitem.getBoundingClientRect();
          itemHeight = rect.height;
        }
        if (subitem.childNodes.length < 2) {
          itemChange = subitem;
        }





      })
      if (!itemChange) return;
      itemChange.style.height = `${itemHeight}px`;



    })


  }


}
customElements.define("heading-text", HeadingText);

class DesktopMenu extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.bindEvents();
    this.changeFontColor();
  }

  bindEvents() {
    this.delegateElement.on("mouseover", '[data-action="toggle-image"]', this.changeImage.bind(this));
  }

  changeImage(event) {
    const activeImage = event.target.getAttribute("data-src");
    const imageWrapper = this.element.querySelector("[data-images_available]");
    const img = this.element.querySelector(".changeImage");

    // Keep the current image when a link has no hover asset — toggling
    // display/recreating the <img> reflows the panel and makes Subscribe flicker.
    if (!activeImage || !img) {
      return;
    }

    if (imageWrapper) {
      imageWrapper.style.display = "block";
    }

    if (img.dataset.hoverSrc === activeImage) {
      return;
    }

    img.dataset.hoverSrc = activeImage;
    img.src = activeImage;
  }

  changeFontColor() {
    let link_list = document.querySelectorAll('.desktopMenu-LinkBox a');
    link_list.forEach((link) => {
      link.addEventListener('mouseover', (event) => {
        let siblings = getSiblings(event.target.parentElement);
        siblings.forEach((sibling) => {
          let element = sibling.querySelector('a');
          if (element.classList) {
            element.classList.add('not-active-link');
          }
        });
      });

      link.addEventListener('mouseleave', (event) => {
        let siblings = getSiblings(event.target.parentElement);
        siblings.forEach((sibling) => {
          let element = sibling.querySelector('a');
          if (element.classList) {
            element.classList.remove('not-active-link');
          }
        });
      });
    });

    let getSiblings = function (e) {
      let siblings = [];
      if (!e.parentNode) {
        return siblings;
      }
      let sibling = e.parentNode.firstChild;
      while (sibling) {
        if (sibling.nodeType === 1 && sibling !== e) {
          siblings.push(sibling);
        }
        sibling = sibling.nextSibling;
      }
      return siblings;
    };
  }
}

customElements.define("desktop-menu", DesktopMenu);


class ImageText extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.scrollBehaviorListener = this.scrollBehavior.bind(this);
    this.lastKnownScrollPosition = 0;
    this.scrollListener = false;
    this.translateMovement = 0;
    if (this.element.dataset.animation == 'true') {
      this.createObserver();
    }


  }


  createObserver() {
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.5,
    });


    this.observer.observe(this.element);
  }

  handleIntersect(entries) {
    const self = this;
    entries.forEach((entry) => {

      if (entry.intersectionRatio === 1 || entry.isIntersecting == true && this.scrollListener == false) {
        self.createScroll();
        this.scrollListener = true;
      } else if (this.scrollListener == true) {
   
        self.destroyScroll();
      }
    });
  }


  createScroll() {
    this.scrollListener = true;
    this.translateMovement = 0;
    window.addEventListener('scroll', this.scrollBehaviorListener);
  }

  destroyScroll() {
    this.scrollListener = false;
    window.removeEventListener('scroll', this.scrollBehaviorListener);
  }

  scrollBehavior() {
    if (this.lastKnownScrollPosition == 0) {
      this.lastKnownScrollPosition = window.scrollY;
    }
    const currentScrollPosition = window.scrollY;
    const scrollDifference = parseInt(currentScrollPosition - this.lastKnownScrollPosition);

    this.translateMovement = this.translateMovement + scrollDifference;

    this.element.querySelector('.ImageText--image .AspectRatio').style.transform = `translateY(${this.translateMovement / 40}px) scale(1.1, 1.1)`;

    this.lastKnownScrollPosition = currentScrollPosition;
  }

}
customElements.define("image-text", ImageText);

class AnimatedAnnBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.announcementBar = document.querySelector('.announcementBar');


    this.updateVisibleHeight();
    this.transitionSpeed = this.element.getAttribute('data-settings');
    this.animWrapper = this.element.querySelector('.AnnBar--AnimWrapper');
    this.original = this.element.querySelector('.AnnBar--DuplicateWrapper');
    if(this.original.children.length == 1) this.original.style.justifyContent = 'center';
    else this.original.style.justifyContent = 'space-between';

    this.bindEvents();
  }

  bindEvents() {
    const debouncedFunc = debounce(this.handleBreakpointChange.bind(this), 100);
    window.addEventListener("resize", debouncedFunc);
    this.handleBreakpointChange();

    window.addEventListener('scroll', this.updateVisibleHeight.bind(this));
    window.addEventListener('resize', this.updateVisibleHeight.bind(this));
  }

  updateVisibleHeight() {
    const rect = this.announcementBar.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // Calculate the visible height
    let visibleHeight = Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);

    // Ensure the visibleHeight is never negative
    visibleHeight = Math.max(visibleHeight, 0);

    // Update the height of .announcementBar with the visible height
    document.documentElement.style.setProperty('--announcement-height', `${visibleHeight}px`);
  }


  handleBreakpointChange() {
    if (new Responsive().matchesBreakpoint("lap-and-up")) {
      this.mobile = false;
      if (this.transitionSpeed) {
        this.duplicateBlockWrappers();
      } else {
        Array.from(this.original.children).forEach((block, i) => block.style.display = 'block');
        this.original.style.justifyContent = 'space-between';
      }
    } else {
      this.mobile = true;
      if (this.transitionSpeed) {
        this.duplicateBlockWrappers();
      } else {
        Array.from(this.original.children).forEach((block, i) => { if (i != 0) block.style.display = 'none' });
        this.original.style.justifyContent = 'center';
      }
    }
  }

  resetWrapper() {
    Array.from(this.animWrapper.children).forEach((child, i) => { if (i != 0) this.animWrapper.removeChild(this.animWrapper.lastChild) });
    this.originalNew = this.element.offsetWidth - (parseInt(getComputedStyle(this.element).paddingLeft) * 2);
  }

  duplicateBlockWrappers() {
    this.resetWrapper();
    const duplicate = this.original.cloneNode(true),
      spaceDiv = document.createElement('div');

    var originalWidth = originalWidth = this.original.offsetWidth;
    if (this.originalNew) originalWidth = this.originalNew;

    if (this.mobile) {
      duplicate.style.width = (originalWidth * this.original.children.length - window.innerWidth) + 'px';
      this.original.style.width = (originalWidth * this.original.children.length - window.innerWidth) + 'px';
      if (this.original.children.length > 2) this.animWrapper.style.width = (2 * (originalWidth * this.original.children.length - window.innerWidth)) + "px";
      else this.animWrapper.style.width = (2 * (originalWidth * this.original.children.length)) + "px";

      if (this.original.children.length >= 2) this.spaceDivWidth = this.getDistanceBetweenBlocks(this.original.children[0], this.original.children[1])
      else this.spaceDivWidth = 0;
    }
    else {
      if (this.original.children.length >= 2) this.spaceDivWidth = this.getDistanceBetweenBlocks(this.original.children[0], this.original.children[1])
      else this.spaceDivWidth = 0;

      duplicate.style.width = originalWidth + 'px';
      this.original.style.width = originalWidth + 'px';
      this.animWrapper.style.width = (2 * originalWidth + this.spaceDivWidth) + "px";
    }

    duplicate.setAttribute("aria-hidden", "true");
    spaceDiv.setAttribute("aria-hidden", "true");
    spaceDiv.style.width = this.spaceDivWidth + 'px';
    this.animWrapper.style.position = "absolute";

    this.element.style.height = this.animWrapper.offsetHeight + 'px';

    this.animWrapper.appendChild(spaceDiv);
    this.animWrapper.appendChild(duplicate);
   
 requestAnimationFrame(this.startAnimating.bind(this));
  }

  startAnimating() {
    this.animWrapper.animate(
      [
        { transform: `translateX(0px)` },
        { transform: `translateX(calc(-50% - ${this.spaceDivWidth / 2}px))` }
      ],
      {
        duration: parseInt(this.transitionSpeed) * 1000,
        iterations: Infinity,
        fill: 'forwards',
        easing: 'linear'
      }
    );
  }

  getDistanceBetweenBlocks(blockOne, blockTwo) {
    return blockTwo.getBoundingClientRect().left - blockOne.getBoundingClientRect().right;
  }
}
customElements.define("animated-announcement-bar", AnimatedAnnBar);



class FAQSection extends HTMLElement {
  constructor() {
    super();
    let foundOne = false;

    const noneTerms = this.querySelector('.noTerms');
    this.clearBtn = this.querySelector('.clearSeacrh');
    this.delegateElement = new Delegate(this);
    const searchInput = document.querySelector('input[rel="searchbox"]');
    this.data = document.querySelectorAll(".Faq-Section");
    this.bindEvents();

    this.show(false);
    const _this=this;
    searchInput.addEventListener('input', function (event) {

        // reset state
        _this.show(false)
        foundOne = false;
        _this.clearBtn.style.display = 'none';
        const input = event.target

        if (input.value) {
          _this.clearBtn.style.display = 'block';
          const toMatch = input.value.toLowerCase();

            for (let i = 0, len = _this.data.length; i < len; i++) {
                const match = _this.data[i].innerHTML.toLowerCase().includes(toMatch);
                _this.data[i].style.display = match ? 'block' : 'none';
                if (match) foundOne = true;
                _this.faqSearch();
            }
          if (!foundOne) {
            _this.show(true);
            noneTerms.innerHTML = input.value;
          }
        } else
        _this.resetState()
        _this.faqSearch();

    });
  }
    bindEvents() {
      document.addEventListener("DOMContentLoaded", this.calculateHeightHeader.bind(this));
      window.addEventListener("resize", this.calculateHeightHeader.bind(this));

      
    this.delegateElement.on(
      "click",
      '[data-action="clear-search"]',
      this.resetState.bind(this)
    );
    

    document.addEventListener("DOMContentLoaded", function() { 
       let links = document.querySelectorAll(".FAQNav--rowLink");

      links.forEach(function(link) {
        link.addEventListener("click", function(event) {
          links.forEach(function(link) {
            link.classList.remove("underline");
          });

          link.classList.add("underline");
        });
      });
    });

    document.addEventListener("DOMContentLoaded", function() {
      let links = document.querySelectorAll(".FAQNav--rowLink");

      links.forEach(function(link) {
        link.classList.remove("underline");
        if (link.href === location.href) {
          link.classList.add("underline");
        }
      });
    });
  }




  calculateHeightHeader(){
    const headerElement = document.querySelector('.Faq--mainHeading');

    if (headerElement) {

        const height = headerElement.offsetHeight;

        document.documentElement.style.setProperty('--header-faq-height', height + "px");

    }
  }

   faqSearch() {
      let faqs = document.querySelectorAll('.FAQ--Terms');
        let search_query = document.getElementById("searchbox").value;
        for (var i = 0; i < faqs.length; i++) {
            if(faqs[i].textContent.toLowerCase()
                    .includes(search_query.toLowerCase())) {
                faqs[i].classList.remove("is-hidden");
            } else {
                faqs[i].classList.add("is-hidden");
            }
        }
    }


     resetState() {
        for (let i = 0, len = this.data.length; i < len; i++){

          this.data[i].style.display = 'block';
        }

            this.show(false);
            this.inputValue = this.querySelector('#searchbox');

            this.inputValue.value = '';
            this.clearBtn.style.display = 'none'
    }

    show(bool) {
      none.style.display = bool ? 'block' : 'none';
    }

}
customElements.define('faq-section', FAQSection);

sessionStorage.setItem('firstLoadCustomRecomm', true);
class RecommCustom extends HTMLElement {
  constructor() {
    super();

    if (sessionStorage.getItem('firstLoadCustomRecomm') === 'true') {
      sessionStorage.setItem('firstLoadCustomRecomm', false);
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations-custom');
          if (recommendations && recommendations.innerHTML.trim().length) {
            const recommNew = recommendations.querySelector(".RecommCustom--ProductCards");
            const recommOld = this.querySelector(".RecommCustom--ProductCards");
            recommOld.parentNode.replaceChild(recommNew, recommOld);
            if (window.theme.enableAnimations) {
            new RevolutionAnimation(recommNew);
            }
          }
        })
        .catch(e => {
          console.error(e);
        });
    }
  }
}
customElements.define("product-recommendations-custom", RecommCustom);

class ConnectedItems extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElem = new Delegate(this.element);
    this.selectedValue = this.element.querySelector('.SelectboxCircle-Selected');
    if(this.selectedValue) this.selectedValue = this.selectedValue.dataset.value
    this.reset = true;
    this.titleText = this.element.querySelector('.ConnectedItems--Title');

    if(this.element.classList.contains('ColorSwatch')) this.bindEvents();
  }

  bindEvents() {
    const labelsOnHover = this.element.querySelectorAll('[data-action="selectbox-hover"]');
    labelsOnHover.forEach(item => item.addEventListener("mouseenter", this.selectboxSetValue.bind(this)));
    labelsOnHover.forEach(item => item.addEventListener("mouseleave", this.selectboxResetValue.bind(this)))
  }

  selectboxSetValue(e) {
    var value = e.target.getAttribute("data-value");
    this.titleText.innerHTML  = value;
    if (this.resetTimeout) clearTimeout(this.resetTimeout);
  }

  selectboxResetValue() {
    this.resetTimeout = setTimeout(() => {
      if (this.reset) this.selectedValue ? this.titleText.innerHTML  = this.selectedValue : this.titleText.innerHTML = window.variantStrings.unavailable;
    }, 175)
  }
}
customElements.define("connected-items", ConnectedItems);